/* Sem Costura — interatividade mínima em JS vanilla */
(function initAnnouncementScroll() {
  function init() {
    var top = document.querySelector('.site-top');
    var announcement = document.querySelector('.announcement');
    if (!top || !announcement) return;
    var mobile = matchMedia('(max-width:767px)');
    var lastY = Math.max(0, scrollY), pending = false;
    function size() {
      document.documentElement.style.setProperty('--announcement-height', announcement.getBoundingClientRect().height + 'px');
      if (!mobile.matches) top.classList.remove('is-announcement-hidden');
    }
    function update() {
      pending = false;
      if (document.body.classList.contains('sc-scroll-locked')) return;
      var y = Math.max(0, scrollY), delta = y - lastY;
      if (!mobile.matches || y <= 80) top.classList.remove('is-announcement-hidden');
      else if (Math.abs(delta) >= 4) top.classList.toggle('is-announcement-hidden', delta > 0);
      if (Math.abs(delta) >= 4 || y <= 80) lastY = y;
    }
    addEventListener('scroll', function() {
      if (!pending) { pending = true; requestAnimationFrame(update); }
    }, {passive:true});
    addEventListener('resize', size, {passive:true});
    mobile.addEventListener('change', size);
    if (window.ResizeObserver) new ResizeObserver(size).observe(announcement);
    size();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();

(function initShelfTabs() {
  if (document.__scTabsShelfDelegated) return;
  document.__scTabsShelfDelegated = true;
  function activate(shelf, index) {
    shelf.querySelectorAll('[data-tabs-shelf-tab]').forEach(function(tab, i) {
      tab.setAttribute('aria-selected', String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      tab.classList.toggle('is-active', i === index);
    });
    shelf.querySelectorAll('[data-tabs-shelf-panel]').forEach(function(panel, i) {
      panel.hidden = i !== index;
      panel.classList.toggle('is-active', i === index);
    });
    shelf.dispatchEvent(new CustomEvent('sc:home-tab-change', {bubbles:true}));
  }
  function onTab(event) {
    var tab = event.target.closest('[data-tabs-shelf-tab]');
    if (!tab) return;
    var shelf = tab.closest('.tabs-shelf');
    var tabs = Array.from(shelf.querySelectorAll('[data-tabs-shelf-tab]'));
    var index = tabs.indexOf(tab);
    if (event.type === 'keydown') {
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = tabs.length - 1;
      else return;
      event.preventDefault(); tabs[index].focus();
    }
    activate(shelf, index);
  }
  document.addEventListener('click', onTab);
  document.addEventListener('keydown', onTab);
})();

(function () {
  "use strict";
  document.documentElement.classList.remove("no-js");

  /* ================================================================
   * SC.bodyLock — trava de scroll iOS-safe, com refcount.
   *
   * Por que existe: no iOS, `document.body.style.overflow = 'hidden'`
   * NÃO trava a página. A única forma correta é `position: fixed` no
   * body com `top: -<scrollY>px` — e restaurar `window.scrollTo` no
   * unlock (senão a pessoa volta pro topo do catálogo).
   * Como usar: SC.bodyLock.lock() ao abrir overlay, SC.bodyLock.unlock()
   * ao fechar. Refcount cobre overlays empilhados (ex.: notify sobre
   * PDP com drawer aberto) sem restaurar cedo demais.
   * ================================================================ */
  var SC = window.SC = window.SC || {};
  SC.bodyLock = (function () {
    var count = 0;
    var savedY = 0;
    return {
      lock: function () {
        if (count === 0) {
          savedY = window.scrollY || window.pageYOffset || 0;
          var body = document.body;
          body.style.top = "-" + savedY + "px";
          body.classList.add("sc-scroll-locked");
          document.documentElement.classList.add("sc-scroll-locked");
        }
        count++;
      },
      unlock: function () {
        if (count === 0) return;
        count--;
        if (count === 0) {
          var body = document.body;
          body.classList.remove("sc-scroll-locked");
          document.documentElement.classList.remove("sc-scroll-locked");
          body.style.top = "";
          window.scrollTo(0, savedY);
        }
      },
      reset: function () {
        count = 0;
        var body = document.body;
        body.classList.remove("sc-scroll-locked");
        document.documentElement.classList.remove("sc-scroll-locked");
        body.style.top = "";
      },
    };
  })();

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
  }

  ready(function init() {
  // --- Mobile nav (painel full-screen `.mnav`) -------------------------------
  (function initMnavDelegation() {
    if (window.__scMnavDelegated) return;
    window.__scMnavDelegated = true;
    var lastScroll = 0;

    function getMnav() { return document.querySelector("[data-mnav]"); }
    function getToggle() { return document.querySelector("[data-mobile-nav-toggle]"); }
    function getSubs(mnav) { return mnav ? mnav.querySelectorAll("[data-mnav-sub]") : []; }
    function resetSubs(mnav) {
      getSubs(mnav).forEach(function (s) {
        s.classList.remove("is-open");
        s.setAttribute("aria-hidden", "true");
      });
    }
    function closeMnav() {
      var mnav = getMnav();
      if (!mnav) return;
      if (mnav.classList.contains("is-open")) SC.bodyLock.unlock();
      mnav.classList.remove("is-open");
      mnav.setAttribute("aria-hidden", "true");
      mnav.setAttribute("hidden", "");
      var toggle = getToggle();
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("mnav-open");
      resetSubs(mnav);
    }
    function openMnav() {
      var mnav = getMnav();
      if (!mnav) return;
      if (!mnav.classList.contains("is-open")) SC.bodyLock.lock();
      resetSubs(mnav);
      mnav.removeAttribute("hidden");
      mnav.setAttribute("aria-hidden", "false");
      mnav.classList.add("is-open");
      var toggle = getToggle();
      if (toggle) toggle.setAttribute("aria-expanded", "true");
      document.documentElement.classList.add("mnav-open");
    }
    function openSub(id) {
      var mnav = getMnav();
      if (!mnav) return;
      var scroll = mnav.querySelector("[data-mnav-scroll]");
      if (scroll) lastScroll = scroll.scrollTop;
      getSubs(mnav).forEach(function (s) {
        var match = s.getAttribute("data-mnav-sub") === id;
        s.classList.toggle("is-open", match);
        s.setAttribute("aria-hidden", match ? "false" : "true");
      });
    }
    function backSub() {
      var mnav = getMnav();
      if (!mnav) return;
      resetSubs(mnav);
      var scroll = mnav.querySelector("[data-mnav-scroll]");
      requestAnimationFrame(function () { if (scroll) scroll.scrollTop = lastScroll; });
    }

    closeMnav();

    document.addEventListener("click", function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var toggle = target.closest("[data-mobile-nav-toggle]");
      if (toggle) { e.preventDefault(); openMnav(); return; }
      var mnav = getMnav();
      if (!mnav || !mnav.classList.contains("is-open")) return;
      if (target === mnav) { closeMnav(); return; }
      var closer = target.closest("[data-mnav-close]");
      if (closer) { e.preventDefault(); closeMnav(); return; }
      var pusher = target.closest("[data-mnav-open-sub]");
      if (pusher) { e.preventDefault(); openSub(pusher.getAttribute("data-mnav-open-sub")); return; }
      var backer = target.closest("[data-mnav-back]");
      if (backer) { e.preventDefault(); backSub(); return; }
      var nav = target.closest("[data-mnav-nav]");
      if (nav || target.closest("[data-open-cart]") || target.closest("[data-open-search]")) closeMnav();
    }, true);

    document.addEventListener("keydown", function (e) {
      var mnav = getMnav();
      if (e.key !== "Escape" || !mnav || !mnav.classList.contains("is-open")) return;
      if (mnav.querySelector(".mnav__sub.is-open")) backSub();
      else closeMnav();
    });
  })();

  // --- Cart drawer -----------------------------------------------------------
  const drawer = document.querySelector("[data-cart-drawer]");
  const overlay = document.querySelector("[data-cart-overlay]");

  function openDrawer(confirmedCart) {
    if (!drawer || !drawer.classList.contains("is-open")) SC.bodyLock.lock();
    drawer && drawer.classList.add("is-open");
    overlay && overlay.classList.add("is-open");
    if (confirmedCart && Array.isArray(confirmedCart.items)) renderCart(confirmedCart);
    else refreshCart();
  }
  function closeDrawer() {
    if (drawer && drawer.classList.contains("is-open")) SC.bodyLock.unlock();
    drawer && drawer.classList.remove("is-open");
    overlay && overlay.classList.remove("is-open");
  }
  document.addEventListener("click", (e) => {
    const target = e.target && e.target.closest ? e.target : null;
    if (!target) return;
    if (target.closest("[data-open-cart]")) { e.preventDefault(); openDrawer(); return; }
    if (target.closest("[data-close-cart]")) { e.preventDefault(); closeDrawer(); return; }
    if (overlay && e.target === overlay) closeDrawer();
  }, true);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) closeDrawer();
  });
  // Fecha o drawer ao clicar em qualquer link marcado (mini-grid do estado vazio)
  document.addEventListener("click", (e) => {
    const t = e.target.closest && e.target.closest("[data-close-cart-link]");
    if (t) closeDrawer();
  });

  const money = (cents) => {
    const value = Number(cents) / 100;
    try {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: window.Shopify?.currency?.active || "BRL" }).format(value);
    } catch (_) {
      return "R$ " + value.toFixed(2).replace(".", ",");
    }
  };

  let cartReadSequence = 0;
  let cartRenderRevision = 0;
  let cartRefreshRequest = 0;
  async function fetchCart() {
    const root = window.Shopify?.routes?.root || "/";
    const url = root + "cart.js?sc_cart_read=" + Date.now() + "-" + (++cartReadSequence);
    const r = await fetch(url, { cache: "no-store", credentials: "same-origin", headers: { Accept: "application/json" } });
    if (!r.ok) throw new Error("cart-read-failed");
    const cart = await r.json();
    if (!Array.isArray(cart?.items) || !Number.isFinite(cart.item_count) || !Number.isFinite(cart.total_price)) throw new Error("cart-read-invalid");
    return cart;
  }

  function presalePropertiesNeedSync(form) {
    return Array.from(form.querySelectorAll("[data-cart-line-key]")).some((line) => {
      return (line.dataset.prevendaCurrent || "") !== (line.dataset.prevendaExpected || "");
    });
  }

  async function syncPresalePropertiesBeforeCheckout(form, cartSnapshot) {
    if (!presalePropertiesNeedSync(form)) return;
    const expectedByKey = new Map();
    form.querySelectorAll("[data-cart-line-key]").forEach((line) => {
      expectedByKey.set(line.dataset.cartLineKey || "", line.dataset.prevendaExpected || "");
    });
    const cart = cartSnapshot || await fetchCart();
    for (const item of cart.items || []) {
      if (!expectedByKey.has(item.key)) continue;
      const expected = expectedByKey.get(item.key) || "";
      const current = String((item.properties && item.properties["Pré-venda"]) || "");
      if (current === expected) continue;
      const properties = Object.assign({}, item.properties || {});
      if (expected) properties["Pré-venda"] = expected;
      // O Cart Ajax responde 200 mas trata `properties: {}` como no-op.
      // Valor vazio é a forma efetiva de apagar a exibição no checkout sem
      // remover e recriar a linha (o que poderia alterar descontos/estoque).
      else properties["Pré-venda"] = "";
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: properties }),
      });
      if (!response.ok) throw new Error("presale-cart-sync-failed");
      const line = form.querySelector('[data-cart-line-key="' + CSS.escape(item.key) + '"]');
      if (line) line.dataset.prevendaCurrent = expected;
    }
  }

  function resetCheckoutPendingState() {
    document.querySelectorAll("[data-presale-drawer-checkout]").forEach((link) => {
      link.dataset.checkoutPending = "false";
      link.removeAttribute("aria-busy");
      link.removeAttribute("aria-disabled");
    });
    document.querySelectorAll("[data-presale-cart-form]").forEach((form) => {
      form.dataset.presaleSynced = "false";
      const button = form.querySelector('[name="checkout"]');
      if (button) button.disabled = false;
    });
  }

  window.addEventListener("pageshow", resetCheckoutPendingState);

  document.addEventListener("submit", async (event) => {
    const form = event.target && event.target.closest
      ? event.target.closest("[data-presale-cart-form]")
      : null;
    if (!form) return;
    const checkoutButton = event.submitter || form.querySelector('[name="checkout"]');
    if (!checkoutButton || checkoutButton.name !== "checkout") return;
    event.preventDefault();
    checkoutButton.disabled = true;
    try {
      await syncPresalePropertiesBeforeCheckout(form);
      const checkoutUrl = checkoutButton.dataset.checkoutUrl || "/checkout?channel=online_store";
      window.location.assign(window.SC?.coupons?.checkoutUrl?.(checkoutUrl) || checkoutUrl);
    } catch (error) {
      console.error(error);
      checkoutButton.disabled = false;
      alert("Atualizamos os prazos da sua sacola. Recarregue a página e tente novamente.");
    }
  }, true);

  document.addEventListener("click", async (event) => {
    const checkoutLink = event.target && event.target.closest
      ? event.target.closest("[data-presale-drawer-checkout]")
      : null;
    if (!checkoutLink || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (checkoutLink.dataset.checkoutPending === "true") return;
    checkoutLink.dataset.checkoutPending = "true";
    checkoutLink.setAttribute("aria-busy", "true");
    checkoutLink.setAttribute("aria-disabled", "true");
    try {
      const presaleForm = document.querySelector("[data-presale-drawer-sync]");
      if (!presaleForm) throw new Error("presale-drawer-sync-missing");
      await syncPresalePropertiesBeforeCheckout(presaleForm);
      window.location.assign(window.SC?.coupons?.checkoutUrl?.(checkoutLink.href) || checkoutLink.href);
    } catch (error) {
      console.error(error);
      checkoutLink.dataset.checkoutPending = "false";
      checkoutLink.removeAttribute("aria-busy");
      checkoutLink.removeAttribute("aria-disabled");
      alert("Não foi possível iniciar o checkout. Tente novamente.");
    }
  }, true);

  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  }

  let lastAddedKey = null;
  // Debounce buffer for stepper mutations (one flight per line key).
  const pendingQty = new Map();   // key -> target quantity
  const pendingTimer = new Map(); // key -> timeout id
  const inFlight = new Set();     // keys currently posting

  function updateShippingBar(cart) {
    const bar = document.querySelector("[data-ship-bar]");
    if (!bar) return;
    const drawer = document.querySelector("[data-cart-drawer]");
    const threshold = Number(drawer?.dataset.freeShippingThreshold || 9900);
    bar.removeAttribute("aria-busy");
    const progress = bar.querySelector("[data-ship-fill]");
    if (progress) progress.style.visibility = "";
    if (cart.item_count === 0) {
      bar.hidden = true;
      if (progress) progress.style.width = "0%";
      const message = bar.querySelector("[data-ship-msg]");
      if (message) message.textContent = "";
      return;
    }
    bar.hidden = false;
    const subtotal = Number(cart.items_subtotal_price || 0);
    const pct = Math.min(100, (subtotal / threshold) * 100);
    const remaining = Math.max(0, threshold - subtotal);
    const fill = bar.querySelector("[data-ship-fill]");
    const msg = bar.querySelector("[data-ship-msg]");
    if (fill) fill.style.width = pct + "%";
    if (msg) {
      msg.innerHTML = remaining === 0
        ? "Você ganhou frete grátis! 🎉"
        : "Faltam <strong>" + money(remaining) + "</strong> para o frete grátis";
    }
  }

  // Legacy complementary upsell (loadUpsell/renderUpsell + [data-cart-upsell])
  // removed in favor of the SSR layered ruler rendered by cart-upsells.js.

  /* [data-cart-scroll] e [data-cart-empty] são AMBOS flex:1 na coluna do
     drawer. Se os dois ficarem visíveis eles dividem a altura, e o estado
     vazio — que carrega a grade de "Mais vendidos" — fica com metade do
     espaço: a imagem achata e a 2a linha de cards some. São mutuamente
     exclusivos por definição, então trocamos junto e em um só lugar. */
  function setScrollHidden(hidden) {
    var el = document.querySelector("[data-cart-scroll]");
    if (el) el.hidden = !!hidden;
  }

  function renderCart(cart) {
    cartRenderRevision++;
    document.dispatchEvent(new CustomEvent("sc:cart-updated", {detail: cart}));
    const bodyEl = document.querySelector("[data-cart-body]");
    const footEl = document.querySelector("[data-cart-foot]");
    const emptyEl = document.querySelector("[data-cart-empty]");
    const subtotalEl = document.querySelector("[data-cart-subtotal]");
    const countLabel = document.querySelector("[data-cart-count-label]");
    const countEls = document.querySelectorAll("[data-cart-count]");

    countEls.forEach((el) => {
      el.textContent = cart.item_count || "";
      el.style.display = cart.item_count > 0 ? "" : "none";
    });
    if (countLabel) countLabel.textContent = cart.item_count > 0 ? "(" + cart.item_count + ")" : "";

    updateShippingBar(cart);

    if (!bodyEl || !footEl || !emptyEl) return;

    if (cart.item_count === 0) {
      bodyEl.innerHTML = "";
      footEl.hidden = true;
      emptyEl.hidden = false;
      // O scroll é flex:1 igual ao empty: deixá-lo visível aqui faria os dois
      // dividirem a altura e comprimirem a grade de "Mais vendidos".
      setScrollHidden(true);
      return;
    }

    emptyEl.hidden = true;
    setScrollHidden(false); // par do setScrollHidden(true) do caminho vazio
    footEl.hidden = false;
    subtotalEl && (subtotalEl.textContent = money(cart.total_price));

    // Descontos de CARRINHO (não de linha). Mesmo container servido pelo
    // Liquid no primeiro paint — atualizado aqui após qualquer /cart/change.
    renderCartDiscounts(cart);

    bodyEl.innerHTML = cart.items.map((item) => {
      const compare = item.original_line_price;
      const final = item.final_line_price;
      const onSale = compare > final;
      // Higiene: NUNCA mostrar "/peça" ou "% OFF" na linha do carrinho.
      // Aprovado com Brenno: no carrinho a decisão já foi tomada; a única
      // informação de preço que importa é o total da linha. O "por peça" segue
      // vivo nas superfícies de DECISÃO (PDP kit picker, LP kits ladder,
      // vitrine "Kits que valem mais a pena" e régua "Complete sua sacola").
      const stripPerPiece = (s) => String(s || "")
        .replace(/\s*[·•|-]?\s*R?\$?\s*[\d.,]+\s*\/\s*(peça|peca|un\b|unidade)/gi, "")
        .replace(/\s*[·•|-]?\s*-?\d+%\s*(off|OFF)?/g, "")
        .replace(/\s+·\s+·\s+/g, " · ")
        .replace(/^\s*·\s*|\s*·\s*$/g, "")
        .trim();
      const rawOpts = (item.variant_options || []).filter(Boolean).map(stripPerPiece).filter(Boolean);
      const opts = rawOpts.join(" · ") || stripPerPiece(item.variant_title) || "";
      const highlight = lastAddedKey === item.key ? " is-highlighted" : "";
      // PRÉ-VENDA (#016) — aqui a fonte é a PROPRIEDADE da linha, não o
      // metafield. O JSON de /cart.js não traz metafields, e buscar um por
      // item seria N+1 numa superfície que re-renderiza a cada mudança de
      // quantidade. A property vem no JSON de graça. Na PÁGINA do carrinho é
      // o contrário: lá é Liquid e lemos o metafield — ver main-cart.liquid.
      // Consequência conhecida: linha adicionada por uma porta que não grava a
      // property não avisa aqui, mas avisa na página do carrinho.
      // O texto sai da PRÓPRIA propriedade: com data ela diz "envio previsto
      // até DD/MM/AAAA", e a nota vira "chegará até DD/MM". Ler a data da
      // propriedade em vez de recalcular garante que sacola e checkout digam o
      // MESMO dia — recalcular faria a data escorregar se a cliente voltasse
      // amanhã.
      //
      // O ramo sem data NÃO é resquício do boolean: é para SACOLA ANTIGA.
      // Carrinho persiste, e quem adicionou antes de 30/jul carrega a
      // propriedade no formato velho. Essa linha vai ao checkout com o texto
      // relativo, então esconder a nota criaria um vão entre sacola e
      // pagamento. Some sozinho quando as sacolas velhas expirarem.
      const propPrevenda = item.properties && item.properties["Pré-venda"];
      let textoPrevenda = "";
      if (propPrevenda) {
        const md = String(propPrevenda).match(/(\d{2})\/(\d{2})\/\d{4}/);
        textoPrevenda = md
          ? "Pré-venda — chegará até " + md[1] + "/" + md[2]
          : "Pré-venda — prazo de entrega estendido em 30 dias";
      }
      const prevenda = textoPrevenda
        ? '<p class="cart-line__prevenda">' +
            '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"/></svg>' +
            '<span>' + escapeHtml(textoPrevenda) + '</span>' +
          '</p>'
        : '';
      return '' +
      '<div class="cart-line' + highlight + '" data-line-key="' + item.key + '" data-product-id="' + item.product_id + '">' +
        '<a class="cart-line__media" href="' + item.url + '" data-close-cart-link>' +
          (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-line__body">' +
          '<div class="cart-line__row">' +
            '<div class="cart-line__meta">' +
              '<h4 class="cart-line__title">' +
                '<a href="' + item.url + '" class="cart-line__title-link" data-close-cart-link>' +
                  escapeHtml(item.product_title) +
                '</a>' +
              '</h4>' +
              '<p class="cart-line__variant">' + escapeHtml(opts) + '</p>' +
              prevenda +
              // Preço DE/POR fica embaixo do título, não na direita do rodapé.
              // Encostado na borda ele era o primeiro a quebrar quando o
              // "Remover" e o seletor de quantidade disputavam a mesma linha
              // em tela estreita. Aqui herda a largura do bloco de texto, que
              // já tem `min-width: 0` e sabe encolher.
              '<p class="cart-line__prices">' +
                (onSale ? '<span class="cart-line__compare">' + money(compare) + '</span>' : '') +
                '<span class="cart-line__price' + (onSale ? ' is-sale' : '') + '">' + money(final) + '</span>' +
              '</p>' +
              renderLineDiscounts(item) +
            '</div>' +
            '<button class="cart-line__remove" data-remove aria-label="Remover">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="cart-line__foot">' +
            '<div class="qty qty--sm">' +
              '<button data-decrease aria-label="Diminuir">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-increase aria-label="Aumentar">+</button>' +
            '</div>' +
            '<button class="cart-line__remove-link" data-remove>Remover</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join("");

    // Store per-line unit price on the row so optimistic updates can recompute
    // the line total without another server round-trip.
    bodyEl.querySelectorAll("[data-line-key]").forEach((row) => {
      const key = row.dataset.lineKey;
      const item = cart.items.find((i) => i.key === key);
      if (!item) return;
      row.dataset.unitPrice = String(item.final_price || Math.round(item.final_line_price / Math.max(1, item.quantity)));
      row.dataset.qty = String(item.quantity);
      // Marca a linha se tem desconto — decisão de "posso recomputar preço
      // otimista?" depende disso. Preço promocional depende do split feito
      // pelo Shopify, que muda quando a quantidade muda; nesses casos não
      // damos palpite, só re-renderizamos após o servidor responder.
      row.dataset.hasDiscount = (item.line_level_discount_allocations && item.line_level_discount_allocations.length) ? "1" : "0";
    });

    ensureCartDelegation();

    if (lastAddedKey) {
      setTimeout(() => {
        lastAddedKey = null;
        bodyEl.querySelectorAll(".cart-line.is-highlighted").forEach((el) => el.classList.remove("is-highlighted"));
      }, 1600);
    }

  }

  // Monta o HTML de chips de desconto por linha a partir do JSON do Cart AJAX.
  // Espelho EXATO de snippets/cart-line-discounts.liquid — se um mudar, o
  // outro tem que mudar no mesmo commit, senão o chip pisca ao mudar a
  // quantidade (bug clássico do drawer). Valores no JSON vêm em CENTAVOS.
  function renderLineDiscounts(item) {
    const allocs = (item && item.line_level_discount_allocations) || [];
    if (!allocs.length) return "";
    const icon = '<svg class="cart-line__discount-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
    const lis = allocs.map(function (a) {
      const title = escapeHtml((a.discount_application && a.discount_application.title) || "");
      return '<li class="cart-line__discount">' + icon +
        '<span class="cart-line__discount-title">' + title + '</span>' +
        '<span class="cart-line__discount-amount">−' + money(a.amount) + '</span>' +
      '</li>';
    }).join("");
    return '<ul class="cart-line__discounts" data-line-discounts>' + lis + '</ul>';
  }

  function renderCartDiscounts(cart) {
    const host = document.querySelector("[data-cart-discounts]");
    if (!host) return;
    const apps = (cart && cart.cart_level_discount_applications) || [];
    if (!apps.length) { host.hidden = true; host.innerHTML = ""; return; }
    const icon = '<svg class="cart-line__discount-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
    host.innerHTML = apps.map(function (app) {
      const title = escapeHtml(app.title || "");
      return '<li class="cart-drawer__discount">' + icon +
        '<span class="cart-drawer__discount-title">' + title + '</span>' +
        '<span class="cart-drawer__discount-amount">−' + money(app.total_allocated_amount || 0) + '</span>' +
      '</li>';
    }).join("");
    host.hidden = false;
  }

  // ---- Single delegated listener on the drawer (survives re-renders) ------
  function ensureCartDelegation() {
    if (!drawer || drawer.dataset.cartDelegated === "1") return;
    drawer.dataset.cartDelegated = "1";
    drawer.addEventListener("click", (e) => {
      const row = e.target.closest && e.target.closest(".cart-line[data-line-key]");
      if (!row || !drawer.contains(row)) return;
      const key = row.dataset.lineKey;
      if (e.target.closest("[data-remove]")) {
        e.preventDefault();
        optimisticRemove(row, key);
        return;
      }
      const dec = e.target.closest("[data-decrease]");
      const inc = e.target.closest("[data-increase]");
      if (!dec && !inc) return;
      e.preventDefault();
      const current = pendingQty.has(key) ? pendingQty.get(key) : Number(row.dataset.qty || 1);
      const next = Math.max(0, current + (inc ? 1 : -1));
      if (next === 0) { optimisticRemove(row, key); return; }
      applyOptimisticQty(row, key, next);
      scheduleChange(key, next);
    });
  }

  function applyOptimisticQty(row, key, qty) {
    pendingQty.set(key, qty);
    row.dataset.qty = String(qty);
    const qtySpan = row.querySelector(".qty span");
    if (qtySpan) qtySpan.textContent = String(qty);
    const priceEl = row.querySelector(".cart-line__price");
    // Se a linha tem desconto ativo, NÃO mexemos no preço otimista — o
    // split que o Shopify faz do desconto muda com a quantidade e nosso
    // palpite (unit * qty) fica errado. Esperar o /cart/change.js e
    // re-renderizar. Money-on-screen tem que ser exato.
    if (priceEl && row.dataset.hasDiscount !== "1") {
      const unit = Number(row.dataset.unitPrice || 0);
      if (unit > 0) priceEl.textContent = money(unit * qty);
    }
    // Recompute subtotal + count optimistically from all rows.
    recomputeTotalsOptimistic();
  }

  function optimisticRemove(row, key) {
    if (row.dataset.removing === "1") return;
    row.dataset.removing = "1";
    pendingQty.set(key, 0);
    row.style.transition = "opacity 150ms ease, transform 150ms ease";
    row.style.opacity = "0";
    row.style.transform = "translateX(8px)";
    setTimeout(() => {
      row.remove();
      recomputeTotalsOptimistic();
      // If drawer is now empty, flip states immediately.
      const bodyEl = document.querySelector("[data-cart-body]");
      if (bodyEl && !bodyEl.querySelector(".cart-line")) {
        const footEl = document.querySelector("[data-cart-foot]");
        const emptyEl = document.querySelector("[data-cart-empty]");
        if (footEl) footEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        setScrollHidden(true);
      }
    }, 150);
    scheduleChange(key, 0);
  }

  function recomputeTotalsOptimistic() {
    if (window.SC?.coupons?.pendingCart?.()) return;
    const bodyEl = document.querySelector("[data-cart-body]");
    if (!bodyEl) return;
    let subtotal = 0;
    let count = 0;
    bodyEl.querySelectorAll(".cart-line[data-line-key]").forEach((r) => {
      if (r.dataset.removing === "1") return;
      const qty = Number(r.dataset.qty || 0);
      const unit = Number(r.dataset.unitPrice || 0);
      subtotal += qty * unit;
      count += qty;
    });
    const subtotalEl = document.querySelector("[data-cart-subtotal]");
    if (subtotalEl) subtotalEl.textContent = money(subtotal);
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = count || "";
      el.style.display = count > 0 ? "" : "none";
    });
    const countLabel = document.querySelector("[data-cart-count-label]");
    if (countLabel) countLabel.textContent = count > 0 ? "(" + count + ")" : "";
    updateShippingBar({ item_count: count, items_subtotal_price: subtotal });
  }

  function scheduleChange(key, qty) {
    pendingQty.set(key, qty);
    if (pendingTimer.has(key)) clearTimeout(pendingTimer.get(key));
    const t = setTimeout(() => flushChange(key), 300);
    pendingTimer.set(key, t);
  }

  async function flushChange(key) {
    pendingTimer.delete(key);
    if (inFlight.has(key)) { // Re-queue if another flight is active.
      scheduleChange(key, pendingQty.get(key));
      return;
    }
    const qty = pendingQty.get(key);
    pendingQty.delete(key);
    inFlight.add(key);
    try {
      const r = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      const cart = await r.json();
      reconcile(cart, key, qty);
    } catch (_) {
      // Rollback on failure by refetching authoritative cart.
      try { renderCart(await fetchCart()); } catch (__) {}
    } finally {
      inFlight.delete(key);
      // If a newer target was queued during the flight, kick another flush.
      if (pendingQty.has(key)) scheduleChange(key, pendingQty.get(key));
    }
  }

  function reconcile(cart, key, expectedQty) {
    if (!cart || typeof cart.item_count !== "number") return;
    document.dispatchEvent(new CustomEvent("sc:cart-updated", {detail: cart}));
    const serverItem = (cart.items || []).find((i) => i.key === key);
    const serverQty = serverItem ? serverItem.quantity : 0;
    // Descontos mexem no preço e podem entrar/sair com a mudança de qty.
    // Se a linha tocada tem (ou tinha) desconto, sempre full re-render para
    // manter o chip e o valor riscado alinhados com o servidor.
    const hasDiscount =
      (serverItem && serverItem.line_level_discount_allocations && serverItem.line_level_discount_allocations.length) ||
      ((cart.cart_level_discount_applications || []).length > 0);
    if (hasDiscount) { renderCart(cart); return; }
    // If server matches our optimistic assumption for this line, only patch totals.
    if (serverQty === expectedQty) {
      const subtotalEl = document.querySelector("[data-cart-subtotal]");
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = cart.item_count || "";
        el.style.display = cart.item_count > 0 ? "" : "none";
      });
      const countLabel = document.querySelector("[data-cart-count-label]");
      if (countLabel) countLabel.textContent = cart.item_count > 0 ? "(" + cart.item_count + ")" : "";
      updateShippingBar(cart);
      if (cart.item_count === 0) {
        const footEl = document.querySelector("[data-cart-foot]");
        const emptyEl = document.querySelector("[data-cart-empty]");
        const bodyEl = document.querySelector("[data-cart-body]");
        if (bodyEl) bodyEl.innerHTML = "";
        if (footEl) footEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        setScrollHidden(true);
      }
      return;
    }
    // Server disagreed (stock cap, promo split, etc.) — full re-render.
    renderCart(cart);
  }

  async function refreshCart() {
    const revision = cartRenderRevision;
    const request = ++cartRefreshRequest;
    try {
      const cart = await fetchCart();
      if (revision !== cartRenderRevision || request !== cartRefreshRequest || pdpCartAdding) return;
      renderCart(cart);
    } catch (_) {}
  }

  // Expose a stable hook for other bundles (e.g. cart-upsells.js) to trigger
  // a full cart re-render after they mutate the cart via /cart/add.js or
  // /cart/change.js. Without this, quick-add buttons on the upsell ruler add
  // the item on the server but the drawer body never repaints, so the user
  // thinks the "+" did nothing.
  window.SC = window.SC || {};
  window.SC.refreshCart = refreshCart;
  window.SC.openDrawer = openDrawer;

  // --- Product forms (PDP add-to-cart) --------------------------------------
  let pdpCartAdding = false;
  document.addEventListener("submit", async (e) => {
    const form = e.target && e.target.closest ? e.target.closest("[data-add-to-cart-form]") : null;
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector("[type=submit]");
    if (pdpCartAdding || !btn || btn.disabled || btn.getAttribute("aria-disabled") === "true") return;
    const variantId = Number(form.querySelector("[data-variant-id], input[name=id]")?.value);
    const quantity = Math.max(1, Number(form.querySelector("[data-qty-input], input[name=quantity]")?.value || 1));
    if (!Number.isSafeInteger(variantId) || variantId <= 0 || !Number.isSafeInteger(quantity)) return;
    let strings = {};
    try { strings = JSON.parse(document.getElementById("sc-coupon-config")?.textContent || "{}").strings || {}; } catch (_) {}
    const addingLabel = strings.adding || "Adicionando…";
    const buttons = [btn, ...document.querySelectorAll("[data-sticky-btn]")];
    const originals = buttons.map(button => ({button, html:button.innerHTML, disabled:button.disabled, busy:button.getAttribute("aria-busy")}));
    let status = form.querySelector("[data-sc-add-status]");
    if (!status) {
      status = document.createElement("span");
      status.className = "visually-hidden";
      status.setAttribute("data-sc-add-status", "");
      status.setAttribute("role", "status");
      status.setAttribute("aria-live", "polite");
      form.append(status);
    }
    pdpCartAdding = true;
    originals.forEach(({button}) => {button.disabled = true; button.setAttribute("aria-busy", "true"); button.textContent = addingLabel;});
    status.textContent = addingLabel;
    const itemAdd = {id:variantId, quantity};
    const prevendaInput = form.querySelector("[data-prevenda-prop]");
    if (prevendaInput) itemAdd.properties = {"Pré-venda":prevendaInput.value};
    let confirmed = false;
    try {
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(root + "cart/add.js?sc_cart=pdp", {
        method:"POST", headers:{"Content-Type":"application/json", Accept:"application/json"},
        body:JSON.stringify({items:[itemAdd]}),
      });
      if (!response.ok) throw new Error("add-failed");
      confirmed = true;
      const data = await response.json();
      const item = data?.items ? data.items[0] : data;
      lastAddedKey = item?.key || null;
      const cart = await fetchCart();
      if (!Array.isArray(cart?.items) || !Number.isFinite(cart.total_price)) throw new Error("cart-read-failed");
      openDrawer(cart);
      status.textContent = strings.added || "Adicionado à sacola.";
    } catch (_) {
      const message = confirmed
        ? (strings.addedRefreshError || "Produto adicionado. Não foi possível atualizar a sacola agora. Abra a sacola para conferir antes de adicionar novamente.")
        : (strings.addFailed || "Não foi possível confirmar a adição. Confira a sacola antes de tentar novamente.");
      status.textContent = message;
      alert(message);
    } finally {
      originals.forEach(({button,html,disabled,busy}) => {
        if (button.textContent === addingLabel) {button.innerHTML = html; button.disabled = disabled;}
        if (busy === null) button.removeAttribute("aria-busy"); else button.setAttribute("aria-busy",busy);
      });
      pdpCartAdding = false;
    }
  }, true);

  // --- PDP: gallery + size selection ----------------------------------------
  const pdp = document.querySelector("[data-pdp]");
  if (pdp) {
    // Tecido é uma família de produtos (não uma variante). O menu próprio abre
    // imediatamente abaixo do botão e cada alternativa mantém uma URL canônica.
    const closeFabricDropdown = (dropdown, restoreFocus = false) => {
      if (!dropdown) return;
      const trigger = dropdown.querySelector("[data-fabric-dropdown-trigger]");
      const menu = dropdown.querySelector("[data-fabric-dropdown-menu]");
      dropdown.classList.remove("is-open");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (menu) menu.hidden = true;
      if (restoreFocus && trigger) trigger.focus();
    };

    const openFabricDropdown = (dropdown) => {
      if (!dropdown) return;
      pdp.querySelectorAll("[data-fabric-dropdown].is-open").forEach((openDropdown) => {
        if (openDropdown !== dropdown) closeFabricDropdown(openDropdown);
      });
      const trigger = dropdown.querySelector("[data-fabric-dropdown-trigger]");
      const menu = dropdown.querySelector("[data-fabric-dropdown-menu]");
      if (!trigger || !menu) return;
      menu.hidden = false;
      dropdown.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    };

    pdp.addEventListener("click", (e) => {
      const trigger = e.target.closest && e.target.closest("[data-fabric-dropdown-trigger]");
      if (trigger && pdp.contains(trigger)) {
        const dropdown = trigger.closest("[data-fabric-dropdown]");
        if (!dropdown) return;
        if (dropdown.classList.contains("is-open")) closeFabricDropdown(dropdown);
        else openFabricDropdown(dropdown);
        return;
      }

      const current = e.target.closest && e.target.closest("[data-fabric-dropdown-current]");
      if (current && pdp.contains(current)) {
        closeFabricDropdown(current.closest("[data-fabric-dropdown]"), true);
      }
    });

    pdp.addEventListener("keydown", (e) => {
      const dropdown = e.target.closest && e.target.closest("[data-fabric-dropdown]");
      if (!dropdown || !pdp.contains(dropdown)) return;
      const trigger = dropdown.querySelector("[data-fabric-dropdown-trigger]");

      if (e.key === "Escape" && dropdown.classList.contains("is-open")) {
        e.preventDefault();
        closeFabricDropdown(dropdown, true);
        return;
      }

      if ((e.key === "ArrowDown" || e.key === "ArrowUp") && e.target === trigger) {
        e.preventDefault();
        openFabricDropdown(dropdown);
        const options = Array.from(dropdown.querySelectorAll("[data-fabric-dropdown-option]"));
        const target = e.key === "ArrowUp" ? options[options.length - 1] : options[0];
        if (target) target.focus();
      }
    });

    document.addEventListener("click", (e) => {
      pdp.querySelectorAll("[data-fabric-dropdown].is-open").forEach((dropdown) => {
        if (!dropdown.contains(e.target)) closeFabricDropdown(dropdown);
      });
    });

    document.addEventListener("focusin", (e) => {
      pdp.querySelectorAll("[data-fabric-dropdown].is-open").forEach((dropdown) => {
        if (!dropdown.contains(e.target)) closeFabricDropdown(dropdown);
      });
    });

    // FULL delivery badge: +3 to +5 business days (Sun skipped).
    // Exposta (não mais IIFE) porque a troca de tamanho precisa recalcular:
    // cada variante pode ter a própria data de pré-venda.
    function renderDelivery() {
      const el = pdp.querySelector("[data-pdp-delivery]");
      if (!el) return;
      const d1El = el.querySelector("[data-delivery-d1]");
      const d2El = el.querySelector("[data-delivery-d2]");
      if (!d1El || !d2El) return;
      function addBiz(from, n) {
        const d = new Date(from);
        let added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0) added++;
        }
        return d;
      }
      const fmt = new Intl.DateTimeFormat("pt-BR", { weekday: "short", day: "numeric", month: "short" });
      function fmtDate(d) {
        const parts = fmt.formatToParts(d);
        const get = (t) => (parts.find((p) => p.type === t)?.value || "").replace(/\.$/, "").toLowerCase();
        return `${get("weekday")}, ${get("day")} ${get("month")}`;
      }
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      // Pré-venda (#016) — `data-delivery-from="YYYY-MM-DD"` é a ÚNICA fonte.
      // Data em que a peça fica disponível para envio. base = max(data, hoje):
      // data no passado degrada para o prazo normal em vez de exibir promessa
      // vencida.
      //
      // NUNCA new Date("2026-09-30"): a string ISO curta é lida como UTC, e no
      // Brasil isso volta UM DIA. O split manual abaixo constrói a data no
      // fuso local, que é onde a cliente vive.
      //
      // O ramo `data-delivery-extra` do boolean saiu em 30/jul, quando os 58
      // do piloto ganharam data. Sem o atributo — 99% do catálogo — base é
      // hoje e a saída fica idêntica à de sempre.
      let base = hoje;
      const from = el.dataset.deliveryFrom;
      if (from) {
        const p = String(from).split("-");
        if (p.length === 3) {
          const d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
          // getTime() NaN = atributo torto; cai no comportamento normal em vez
          // de imprimir "Invalid Date" na promessa de entrega.
          if (!isNaN(d.getTime()) && d > base) base = d;
        }
      }

      const d1 = addBiz(base, 3);
      const d2 = addBiz(base, 5);
      d1El.textContent = fmtDate(d1);
      d2El.textContent = fmtDate(d2);

      // A propriedade de linha carrega a MESMA data que a cliente acabou de
      // ler.
      if (from) {
        const dd = String(d2.getDate()).padStart(2, "0");
        const mm = String(d2.getMonth() + 1).padStart(2, "0");
        sincronizaPropPrevenda("envio previsto até " + dd + "/" + mm + "/" + d2.getFullYear());
      }
    }

    // Cria, atualiza ou remove o input da propriedade de pré-venda conforme a
    // variante escolhida. Precisa CRIAR porque o Liquid só emite o input
    // quando a variante INICIAL tem pré-venda — trocar para um tamanho que
    // tem data, partindo de um que não tinha, exige o nó aparecer do nada.
    // E precisa REMOVER no caminho inverso, senão a cliente leva ao checkout
    // uma promessa que não vale para o tamanho que ela escolheu.
    function sincronizaPropPrevenda(texto) {
      const form = pdp.querySelector("[data-add-to-cart-form]");
      if (!form) return;
      let input = form.querySelector("[data-prevenda-prop]");
      if (!texto) { if (input) input.remove(); return; }
      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = "properties[Pré-venda]";
        input.setAttribute("data-prevenda-prop", "");
        form.appendChild(input);
      }
      input.value = texto;
    }

    renderDelivery();

    // Thumb clicks are handled once in the pdp2 IIFE below (image + video + external swap).

    const variantData = pdp.querySelector("[data-variants-json]");
    const variants = variantData ? JSON.parse(variantData.textContent || "[]") : [];
    const variantInput = pdp.querySelector("[data-variant-id]");
    const priceEl = pdp.querySelector("[data-pdp-price]");
    const installmentsEl = pdp.querySelector("[data-pdp-installments]");
    const maxInstallments = installmentsEl ? Math.max(1, parseInt(installmentsEl.dataset.maxInstallments || "3", 10)) : 3;
    const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
    function renderInstallments(cents) {
      if (!installmentsEl) return;
      const n = Number(cents);
      if (!isFinite(n) || n <= 0) {
        installmentsEl.textContent = `em até ${maxInstallments}x sem juros`;
        return;
      }
      installmentsEl.textContent = `ou ${maxInstallments}x de ${brl.format(n / 100 / maxInstallments)} sem juros`;
    }
    const submitBtn = pdp.querySelector("[data-add-btn]");

    function updateFromSelection() {
      window.SC?.coupons?.resetPdp?.();
      const selected = Array.from(pdp.querySelectorAll("[data-option-value].is-active")).map((el) => el.dataset.value);
      const match = variants.find((v) => JSON.stringify(v.options) === JSON.stringify(selected));
      if (!match && variants.length === 1) {
        if (variantInput) variantInput.value = variants[0].id;
        return;
      }
      if (match) {
        if (variantInput) variantInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        renderInstallments(match.priceCents);
        if (submitBtn) {
          // Botão único que muda de função. Nunca desabilitar — se ficar
          // disabled, o clique não dispara e o modal de aviso some.
          submitBtn.disabled = false;
          submitBtn.removeAttribute("aria-disabled");
          submitBtn.setAttribute("data-variant-label", match.title || "");
          if (match.available) {
            submitBtn.type = "submit";
            submitBtn.removeAttribute("data-open-notify");
            submitBtn.textContent = "Adicionar à sacola";
          } else {
            submitBtn.type = "button";
            submitBtn.setAttribute("data-open-notify", "");
            submitBtn.textContent = "Me avise quando chegar";
          }
        }
        // PRÉ-VENDA POR VARIANTE: cada tamanho pode ter data própria, então a
        // janela e a promessa escrita mudam junto com o swatch. A data vem do
        // data-variants-json que a PDP já embute — nenhuma ida ao servidor.
        const delivEl = pdp.querySelector("[data-pdp-delivery]");
        if (delivEl) {
          if (match.prevendaData) {
            delivEl.dataset.deliveryFrom = match.prevendaData;
          } else {
            delete delivEl.dataset.deliveryFrom;
          }
          renderDelivery();
          // Tamanho novo sem data: a promessa não vale mais e o input tem de
          // sumir, senão a cliente leva ao checkout o prazo do tamanho antigo.
          if (!match.prevendaData) sincronizaPropPrevenda("");
        }

        // Espelha na barra fixa mobile. Container estável = document; o
        // nó da barra pode ser re-renderizado por Section Rendering API.
        const stickyBar = document.querySelector("[data-pdp-sticky]");
        if (stickyBar) {
          const sPrice = stickyBar.querySelector("[data-sticky-price]");
          if (sPrice) sPrice.textContent = match.price;
          const sBtn = stickyBar.querySelector("[data-sticky-btn]");
          if (sBtn) sBtn.textContent = match.available ? "Adicionar" : "Me avise";
          const sSizeWrap = stickyBar.querySelector("[data-sticky-size]");
          const sSizeVal = stickyBar.querySelector("[data-sticky-size-val]");
          if (sSizeWrap && sSizeVal) {
            const optName = sSizeWrap.getAttribute("data-size-option-name") || "";
            const grp = pdp.querySelector(
              '[data-option-group][data-option-name="' + optName.replace(/"/g, '\\"') + '"]'
            );
            const active = grp && grp.querySelector("[data-option-value].is-active");
            if (active) sSizeVal.textContent = active.dataset.value;
          }
        }
      }
    }

    // Option groups: delegate on the stable PDP root.
    pdp.addEventListener("click", (e) => {
        const btn = e.target.closest && e.target.closest("[data-option-value]");
        if (!btn || !pdp.contains(btn)) return;
        const group = btn.closest("[data-option-group]");
        if (!group) return;
        group.querySelectorAll("[data-option-value]").forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        const cur = group.querySelector(".pdp__opt-current");
        if (cur) cur.textContent = btn.dataset.value;
        updateFromSelection();
    });

    // Qty control
    const qtyInput = pdp.querySelector("[data-qty-input]");
    const qtyDisplay = pdp.querySelector("[data-qty-display]");
    pdp.addEventListener("click", (e) => {
      if (!(e.target.closest && (e.target.closest("[data-qty-dec]") || e.target.closest("[data-qty-inc]")))) return;
      e.preventDefault();
      const inc = e.target.closest("[data-qty-inc]");
      const delta = inc ? 1 : -1;
      const v = Math.max(1, Number(qtyInput.value || 1) - 1);
      const next = Math.max(1, Number(qtyInput.value || 1) + delta);
      qtyInput.value = next; if (qtyDisplay) qtyDisplay.textContent = next;
    });

    updateFromSelection();
  }


  // --- PDP v0.4.9: modals, sticky bar, kit render, video thumbs ------------
  (function pdp2(){
    const pdp = document.querySelector("[data-pdp]");
    if (!pdp) return;

    // PDP gallery v1.0 — carrossel snap (mobile) + setas/miniaturas/contador (desktop)
    (function pdpGallery(){
      const gallery = pdp.querySelector("[data-pdp-gallery]");
      if (!gallery) return;
      const stage = gallery.querySelector("[data-pdp-stage]");
      const track = gallery.querySelector("[data-pdp-track]");
      if (!stage || !track) return;
      const slides = Array.from(track.querySelectorAll("[data-pdp-slide]"));
      const thumbs = Array.from(gallery.querySelectorAll("[data-pdp-thumb]"));
      const counter = gallery.querySelector("[data-pdp-current]");
      const prev = gallery.querySelector("[data-pdp-prev]");
      const next = gallery.querySelector("[data-pdp-next]");
      if (slides.length <= 1) return;
      // Trava de eixo via CSS aplicada só quando o JS carrega (fail-open):
      // sem JS, .pdp__track segue com scroll nativo e o usuário não fica preso.
      track.classList.add("pdp__track--js");
      let current = 0;
      function setActive(i){
        if (i === current) return;
        current = i;
        thumbs.forEach((t, ti) => t.classList.toggle("is-active", ti === i));
        if (counter) counter.textContent = String(i + 1);
        updateNav();
      }
      function updateNav(){
        if (prev) prev.hidden = current <= 0;
        if (next) next.hidden = current >= slides.length - 1;
      }
      updateNav();
      function goTo(i){
        i = Math.max(0, Math.min(slides.length - 1, i));
        const slide = slides[i];
        if (!slide) return;
        // scrollIntoView pode arrastar a página inteira; usar scrollLeft manual.
        track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
      }
      // Swipe horizontal controlado: trava eixo com viés vertical (fator 1.3),
      // acompanha o dedo 1:1 via scrollLeft, e no soltar decide por deslocamento
      // (>15% da largura) OU velocidade (>0.4 px/ms). Snap desativado durante o
      // arrasto para não brigar com scrollLeft manual.
      let sx = 0, sy = 0, sLeft = 0, sTime = 0, axis = null, active = false;
      track.addEventListener("touchstart", (e) => {
        const t = e.touches && e.touches[0]; if (!t) return;
        sx = t.clientX; sy = t.clientY; sLeft = track.scrollLeft;
        sTime = (e.timeStamp || Date.now()); axis = null; active = true;
      }, { passive: true });
      track.addEventListener("touchmove", (e) => {
        if (!active) return;
        const t = e.touches && e.touches[0]; if (!t) return;
        const dx = t.clientX - sx, dy = t.clientY - sy;
        if (axis === null) {
          if (Math.abs(dx) + Math.abs(dy) < 10) return;
          axis = Math.abs(dx) > Math.abs(dy) * 1.3 ? "x" : "y";
          if (axis === "x") track.classList.add("is-dragging");
          else { active = false; return; }
        }
        if (axis === "x") {
          track.scrollLeft = sLeft - dx;
        }
      }, { passive: true });
      function endDrag(e){
        if (!active) return;
        const wasX = axis === "x";
        active = false;
        if (!wasX) { axis = null; return; }
        const t = (e.changedTouches && e.changedTouches[0]) || null;
        const dx = t ? (t.clientX - sx) : 0;
        const elapsed = Math.max(1, (e.timeStamp || Date.now()) - sTime);
        const vel = Math.abs(dx) / elapsed;
        const stageWidth = stage.getBoundingClientRect().width || track.clientWidth || 1;
        track.classList.remove("is-dragging");
        axis = null;
        let target = current;
        if (Math.abs(dx) > stageWidth * 0.15 || vel > 0.4) {
          target = current + (dx < 0 ? 1 : -1);
        }
        goTo(target);
      }
      track.addEventListener("touchend", endDrag, { passive: true });
      track.addEventListener("touchcancel", endDrag, { passive: true });
      // Distinguir tap de swipe iniciado em cima da seta: se o dedo moveu > 8px,
      // trata como arrasto e ignora o click sintético que o browser dispara.
      let touchStartX = 0, touchStartY = 0, touchMoved = false;
      gallery.addEventListener("touchstart", (e) => {
        const t = e.touches && e.touches[0]; if (!t) return;
        touchStartX = t.clientX; touchStartY = t.clientY; touchMoved = false;
      }, { passive: true });
      gallery.addEventListener("touchmove", (e) => {
        const t = e.touches && e.touches[0]; if (!t) return;
        if (Math.abs(t.clientX - touchStartX) > 8 || Math.abs(t.clientY - touchStartY) > 8) touchMoved = true;
      }, { passive: true });
      gallery.addEventListener("click", (e) => {
        const onNav = e.target.closest && e.target.closest("[data-pdp-prev],[data-pdp-next]");
        if (onNav && touchMoved) { e.preventDefault(); touchMoved = false; return; }
        const thumb = e.target.closest && e.target.closest("[data-pdp-thumb]");
        if (thumb && gallery.contains(thumb)) { e.preventDefault(); goTo(thumbs.indexOf(thumb)); return; }
        if (e.target.closest && e.target.closest("[data-pdp-prev]")) { e.preventDefault(); goTo(current - 1); return; }
        if (e.target.closest && e.target.closest("[data-pdp-next]")) { e.preventDefault(); goTo(current + 1); }
      });
      if ("IntersectionObserver" in window) {
        const io = new IntersectionObserver((entries) => {
          let best = null;
          entries.forEach((e) => {
            if (e.isIntersecting && (!best || e.intersectionRatio > best.intersectionRatio)) best = e;
          });
          if (best) {
            const i = slides.indexOf(best.target);
            if (i >= 0) setActive(i);
          }
        }, { root: track, threshold: [0.55, 0.75, 0.95] });
        slides.forEach((s) => io.observe(s));
      }
      stage.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") { e.preventDefault(); goTo(current - 1); }
        else if (e.key === "ArrowRight") { e.preventDefault(); goTo(current + 1); }
      });
      // Expose for variant/color changes: window.SC.pdpGoTo(i)
      window.SC = window.SC || {};
      window.SC.pdpGoTo = goTo;
    })();

    // Sync selected option label handled by the stable PDP-root delegate above.

    // Render kit cards from JSON
    const kitsWrap = pdp.querySelector(".pdp__kits");
    if (kitsWrap) {
      let opts = [];
      try { opts = JSON.parse(kitsWrap.dataset.kits || "[]"); } catch (_) { opts = []; }
      // Safety-net: dedup por qty (mantém is_current > menor preço numérico).
      const priceNum = (s) => {
        if (typeof s === "number") return s;
        const n = parseFloat(String(s || "").replace(/[^\d,.-]/g, "").replace(/\.(?=\d{3}(\D|$))/g, "").replace(",", "."));
        return isNaN(n) ? Infinity : n;
      };
      const byQty = new Map();
      const extras = [];
      for (const o of opts) {
        if (!o.qty) { extras.push(o); continue; }
        const cur = byQty.get(o.qty);
        if (!cur) { byQty.set(o.qty, o); continue; }
        const better = (o.is_current && !cur.is_current) ||
          (!!o.is_current === !!cur.is_current && priceNum(o.total) < priceNum(cur.total));
        if (better) byQty.set(o.qty, o);
      }
      opts = [...byQty.values(), ...extras];
      // Opções com qty indeterminada (0) vão para o fim.
      opts.sort((a, b) => (a.qty || 999) - (b.qty || 999));
      // Move o atual para primeira posição.
      const curIdx = opts.findIndex((o) => o.is_current);
      if (curIdx > 0) {
        const [cur] = opts.splice(curIdx, 1);
        opts.unshift(cur);
      }
      let bestIdx = 0;
      opts.forEach((o, i) => { if (o.savings > opts[bestIdx].savings) bestIdx = i; });
      const list = kitsWrap.querySelector("[data-kit-list]");
      if (list && opts.length > 1) {
        list.innerHTML = opts.map((o, i) => {
          const isBest = i === bestIdx && o.savings > 0;
          const isMulti = o.qty > 1;
          const cls = "pdp__kit-card" + (o.is_current ? " is-current" : "");
          const tag = o.is_current ? "div" : "a";
          const href = o.is_current ? "" : ' href="' + o.url + '"';
          const shortLabel = o.qty === 1 ? "1 unidade" : (o.qty > 1 ? "Kit com " + o.qty : o.label);
          const priceMain = isMulti
            ? o.per_piece + '<span class="pdp__kit-card__pp-suffix">/peça</span>'
            : o.total;
          return "<" + tag + ' class="' + cls + '"' + href + ">" +
            (isBest ? '<span class="pdp__kit-card__badge">Melhor</span>' : '') +
            '<span class="pdp__kit-card__label">' + shortLabel + '</span>' +
            '<span class="pdp__kit-card__main" data-coupon-product="' + (o.url.split('/products/')[1] || '').split('?')[0] + '"' + (o.is_current ? ' data-coupon-current-pdp' : '') + '>' + priceMain + '</span>' +
            '<span class="pdp__kit-card__savings">' + (o.savings > 0 ? '-' + o.savings + '%' : '') + '</span>' +
            '</' + tag + ">";
        }).join("");
        const sel = opts.find((o) => o.is_current) || opts[0];
        if (sel) {
          let totalEl = kitsWrap.querySelector(".pdp__kit-total");
          if (!totalEl) {
            totalEl = document.createElement("p");
            totalEl.className = "pdp__kit-total";
            kitsWrap.appendChild(totalEl);
          }
          const pieces = sel.qty || 1;
          totalEl.textContent = "Total: " + sel.total + " (" + pieces + " " + (pieces === 1 ? "peça" : "peças") + ")";
        }
      } else {
        kitsWrap.hidden = true;
      }
    }

    // Modal open/close
    function openModal(name) {
      const m = document.querySelector('[data-modal="' + name + '"]');
      if (!m) return;
      if (m.hidden) SC.bodyLock.lock();
      m.hidden = false;
      if (name === "size-guide") highlightSizeGuideRow(m);
    }
    function highlightSizeGuideRow(modal) {
      try {
        const sel = document.querySelector('[data-option-group] .size-swatch.is-active');
        const size = sel ? (sel.getAttribute('data-value') || sel.textContent || '').trim() : '';
        modal.querySelectorAll('[data-sg-row]').forEach((r) => r.classList.remove('is-current'));
        if (!size) return;
        const row = modal.querySelector('[data-sg-row][data-size="' + size.replace(/"/g, '\\"') + '"]');
        if (row) {
          row.classList.add('is-current');
          requestAnimationFrame(() => row.scrollIntoView({ block: 'nearest', behavior: 'auto' }));
        }
      } catch (_) {}
    }
    function closeModal(m) {
      if (!m) return;
      if (!m.hidden) SC.bodyLock.unlock();
      m.hidden = true;
    }
    document.addEventListener("click", (e) => {
      if (e.target.closest && e.target.closest("[data-open-size-guide]")) { e.preventDefault(); openModal("size-guide"); return; }
      const closer = e.target.closest && e.target.closest("[data-modal-close]");
      if (closer) closeModal(closer.closest(".pdp-modal"));
    }, true);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") document.querySelectorAll(".pdp-modal").forEach((m) => { if (!m.hidden) closeModal(m); });
    });

    // Sticky mobile bar
    const cta = pdp.querySelector("[data-pdp-cta]");
    const sticky = document.querySelector("[data-pdp-sticky]");
    if (cta && sticky) {
      const obs = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting;
        sticky.hidden = !show;
        document.body.classList.toggle("has-pdp-sticky", show);
      }, { threshold: 0, rootMargin: "0px 0px -60px 0px" });
      obs.observe(cta);
      document.addEventListener("click", (e) => {
        if (!(e.target.closest && e.target.closest("[data-sticky-add]"))) return;
        e.preventDefault();
        pdp.querySelector("[data-add-btn]")?.click();
      }, true);
    }

    // Rótulo de tamanho na barra fixa → rola até o seletor e destaca.
    document.addEventListener("click", (e) => {
      const t = e.target.closest && e.target.closest("[data-sticky-size]");
      if (!t) return;
      e.preventDefault();
      const optName = t.getAttribute("data-size-option-name") || "";
      const grp = pdp.querySelector(
        '[data-option-group][data-option-name="' + optName.replace(/"/g, '\\"') + '"]'
      );
      if (!grp) return;
      try { grp.scrollIntoView({ behavior: "smooth", block: "center" }); }
      catch { grp.scrollIntoView(); }
      grp.classList.remove("is-flash");
      // reflow para reiniciar a animação
      void grp.offsetWidth;
      grp.classList.add("is-flash");
      setTimeout(() => grp.classList.remove("is-flash"), 1400);
    });

    // Safe sticky da coluna de info: só ativa quando cabe na viewport.
    // Sem overflow interno — evita o "iframe scroll" da buy box.
    const infoCol = pdp.querySelector(".pdp__info");
    if (infoCol) {
      const TOP = 96, BOTTOM = 16;
      const update = () => {
        if (window.innerWidth < 1024) { infoCol.classList.remove("is-sticky"); return; }
        const fits = infoCol.offsetHeight <= window.innerHeight - TOP - BOTTOM;
        infoCol.classList.toggle("is-sticky", fits);
      };
      update();
      let raf = 0;
      const schedule = () => { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(update); };
      window.addEventListener("resize", schedule);
      if ("ResizeObserver" in window) new ResizeObserver(schedule).observe(infoCol);
    }

    // Async product recommendations (native Shopify /recommendations/products.json)
    document.querySelectorAll("[data-recs]").forEach(async (el) => {
      const slot = el.querySelector("[data-recs-slot]");
      if (!slot || slot.children.length > 0) return;
      const pid = el.dataset.productId;
      const intent = el.dataset.intent || "related";
      const limit = el.dataset.limit || 4;
      try {
        const r = await fetch("/recommendations/products?section_id=recommendations&product_id=" + pid + "&intent=" + intent + "&limit=" + limit);
        if (!r.ok) throw new Error("failed");
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const injected = doc.querySelector("[data-recs-slot]");
        if (injected && injected.innerHTML.trim()) {
          slot.innerHTML = injected.innerHTML;
        } else {
          el.hidden = true;
        }
      } catch (_) {
        el.hidden = true;
      }
    });
  })();

  // --- Okendo summary fallback ------------------------------------------------
  // Okendo stores summaryData as json_string in this shop. Liquid exposes that as
  // a string, so server-side dot access returns blank. Hydrate our custom stars
  // from the raw metafield JSON without waiting for the Okendo app script.
  (function hydrateOkendoSummary() {
    const sources = document.querySelectorAll("script[data-oke-summary], [data-oke-summary-raw]");
    let summary = null;
    for (const source of sources) {
      const raw = source.tagName === "SCRIPT" ? source.textContent : source.getAttribute("data-oke-summary-raw");
      summary = parseOkendoSummary(raw);
      if (summary) break;
    }
    if (!summary) return;

    const count = toNumber(summary.reviewCount ?? summary.review_count ?? summary.totalReviews ?? summary.total_reviews);
    const averageRaw = summary.reviewAverageValue ?? summary.averageRating ?? summary.average_rating ?? summary.ratingAverage;
    const average = toNumber(averageRaw);
    if (!count || !average) return;

    const averageText = formatAverage(averageRaw, average);
    const label = averageText + " de 5 estrelas, " + count + " " + (count === 1 ? "avaliação" : "avaliações");

    document.querySelectorAll("[data-rv-stars], [data-oke-stars]").forEach((el) => {
      el.removeAttribute("aria-hidden");
      el.setAttribute("aria-label", label);
      el.innerHTML = renderStars(average, 14) + '<span class="pdp__rating__text" aria-hidden="true">' + averageText + " (" + count + " " + (count === 1 ? "avaliação" : "avaliações") + ")</span>";
    });
  })();

  function parseOkendoSummary(raw) {
    if (!raw) return null;
    let value = String(raw).trim();
    for (let i = 0; i < 2; i += 1) {
      try {
        const parsed = JSON.parse(value);
        if (parsed && typeof parsed === "object") return parsed;
        if (typeof parsed === "string") { value = parsed.trim(); continue; }
      } catch (_) {
        return null;
      }
    }
    return null;
  }

  function toNumber(value) {
    if (value === null || value === undefined || value === "") return 0;
    const n = Number(String(value).replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  }

  function formatAverage(raw, n) {
    const s = String(raw ?? "").trim();
    if (/^\d+(\.\d+)?$/.test(s)) return s;
    return n.toFixed(1).replace(/\.0$/, "");
  }

  function renderStars(rating, size) {
    const fill = Math.max(0, Math.min(100, (rating / 5) * 100));
    const trackStar = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linejoin="round" style="width:var(--rs-size,14px);height:var(--rs-size,14px);display:block;flex:0 0 auto"><path d="M12 3.5l2.65 5.37 5.93.86-4.29 4.18 1.01 5.9L12 17.98l-5.3 2.79 1.01-5.9L3.42 9.73l5.93-.86L12 3.5z"/></svg>';
    const fillStar = '<svg viewBox="0 0 24 24" fill="currentColor" style="width:var(--rs-size,14px);height:var(--rs-size,14px);display:block;flex:0 0 auto"><path d="M12 3.5l2.65 5.37 5.93.86-4.29 4.18 1.01 5.9L12 17.98l-5.3 2.79 1.01-5.9L3.42 9.73l5.93-.86L12 3.5z"/></svg>';
    const track = trackStar + trackStar + trackStar + trackStar + trackStar;
    const filled = fillStar + fillStar + fillStar + fillStar + fillStar;
    return '<span class="rating-stars" style="--rs-size:' + size + 'px;--rs-rating:' + rating + ';--rs-fill:' + fill + '%;position:relative;display:inline-block;line-height:0;color:var(--foreground,#0f0f0f)" aria-hidden="true"><span class="rating-stars__track" style="display:inline-flex;gap:2px;white-space:nowrap">' + track + '</span><span class="rating-stars__fill" style="position:absolute;inset:0 auto auto 0;width:' + fill + '%;max-width:100%;height:100%;overflow:hidden;display:inline-flex;gap:2px;white-space:nowrap;color:var(--foreground,#0f0f0f);pointer-events:none">' + filled + '</span></span>';
  }

    // --- Accordion -------------------------------------------------------------
  document.addEventListener("click", (e) => {
    const btn = e.target.closest && e.target.closest(".accordion__trigger");
    if (!btn) return;
    const item = btn.closest(".accordion__item");
    if (!item) return;
    const open = item.classList.toggle("is-open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  }, true);

  // Initial cart sync (updates badge) — defer to idle so it never blocks paint.
  const idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };
  idle(refreshCart);

  // --- Collection/Search filters (instant apply via Section Rendering API) ---
  initInstantFilters();

  // --- Load more (progressive enhancement over paginate.next) ---------------
  document.addEventListener("click", async (e) => {
      const loadMoreBtn = e.target.closest && e.target.closest("[data-load-more-btn]");
      if (!loadMoreBtn) return;
      e.preventDefault();
      const url = loadMoreBtn.getAttribute("href");
      const wrap = loadMoreBtn.closest("[data-load-more]");
      const grid = document.querySelector("[data-collection-grid]");
      if (!url || !grid) return;
      loadMoreBtn.textContent = "Carregando...";
      loadMoreBtn.style.pointerEvents = "none";
      try {
        const r = await fetch(url, { headers: { Accept: "text/html" } });
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrid = doc.querySelector("[data-collection-grid]");
        if (newGrid) {
          Array.from(newGrid.children).forEach((el) => grid.appendChild(el));
          initSwatches(grid);
        }
        const nextBtn = doc.querySelector("[data-load-more-btn]");
        if (nextBtn) {
          loadMoreBtn.setAttribute("href", nextBtn.getAttribute("href"));
          loadMoreBtn.textContent = "Carregar mais";
          loadMoreBtn.style.pointerEvents = "";
        } else if (wrap) {
          wrap.remove();
        }
      } catch (err) {
        console.error(err);
        loadMoreBtn.textContent = "Tentar novamente";
        loadMoreBtn.style.pointerEvents = "";
      }
  }, true);

  // --- Product card swatches ------------------------------------------------
  function initSwatches(scope) {
    (scope || document).querySelectorAll("[data-product-card]").forEach((card) => {
      if (card.dataset.swatchInit) return;
      card.dataset.swatchInit = "1";
      const primaryImg = card.querySelector(".product-card__media img.primary");
      if (primaryImg) card.dataset.originalImg = primaryImg.getAttribute("src") || "";
    });
  }
  document.addEventListener("click", (e) => {
    const sw = e.target.closest && e.target.closest("[data-product-card] [data-swatch]");
    if (!sw) return;
    const card = sw.closest("[data-product-card]");
    if (!card) return;
    e.preventDefault();
    card.querySelectorAll("[data-swatch]").forEach((s) => s.classList.remove("is-active"));
    sw.classList.add("is-active");
    const primaryImg = card.querySelector(".product-card__media img.primary");
    const activeColor = card.querySelector("[data-active-color]");
    const img = sw.getAttribute("data-image");
    if (primaryImg) primaryImg.setAttribute("src", img || card.dataset.originalImg || "");
    if (activeColor) activeColor.textContent = sw.getAttribute("data-color") || "";
    // Redireciona o card para a URL da variante escolhida (?variant=<id>).
    // 100% cliente — sem rede — porque `data-url` já veio no Liquid do card.
    // Sem esta troca, o card apontaria para a cor "default" e o cliente veria
    // a cor errada ao chegar na PDP.
    var vUrl = sw.getAttribute("data-url");
    if (vUrl) {
      card.querySelectorAll('a[href]').forEach(function (a) {
        // não bagunçar links de review/rating internos, se houver
        if (a.closest("[data-active-color]")) return;
        a.setAttribute("href", vUrl);
      });
    }
    var vPrice = sw.getAttribute("data-price");
    if (vPrice) {
      var priceEl = card.querySelector(".product-card__price .product-card__sale, .product-card__price");
      // Se a variante trouxer preço próprio e for diferente do exibido, atualiza.
      if (priceEl && priceEl.childNodes.length && !card.querySelector(".product-card__compare")) {
        priceEl.textContent = vPrice;
      }
    }
  }, true);
  initSwatches(document);
  document.addEventListener('sc:home-shelf-loaded', function(event) { initSwatches(event.target); });

  // --- FAQ accordion handled by the delegated accordion listener above. ------
  }); // ready
})();
// --- Desktop dropdown a11y ---------------------------------------------------
(function () {
  // Máquina de estado única para o dropdown do header (desktop).
  // - Um único timer compartilhado: trocar entre itens cancela o fechamento pendente
  //   do anterior antes de abrir o novo, sem corrida de timers.
  // - pointerenter/pointerleave apenas no wrapper <li> (não bubblam dos filhos —
  //   evita churn ao passar sobre sublinks e cobre item + ::before ponte + painel).
  (function () {
    var CLOSE_DELAY = 300;
    var items = Array.prototype.slice.call(
      document.querySelectorAll(".site-header__nav-item.has-submenu")
    );
    if (!items.length) return;
    var current = null;      // item atualmente aberto (ou marcado para fechar)
    var closeTimer = null;

    function openItem(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (current && current !== item) {
        current.classList.remove("is-open");
        var prevT = current.querySelector("[data-nav-toggle]");
        if (prevT) prevT.setAttribute("aria-expanded", "false");
      }
      current = item;
      item.classList.add("is-open");
      var toggle = item.querySelector("[data-nav-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", "true");
    }

    function closeNow(item) {
      item.classList.remove("is-open");
      var toggle = item.querySelector("[data-nav-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      if (current === item) current = null;
    }

    function scheduleClose(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      closeTimer = setTimeout(function () {
        closeTimer = null;
        closeNow(item);
      }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var toggle = item.querySelector("[data-nav-toggle]");
      if (!toggle) return;

      // pointerenter/pointerleave: não bubblam dos filhos → um único par de eventos
      // por movimentação real entre o wrapper e o mundo externo. Reentradas em
      // qualquer descendente (item, ponte ::before, painel, sublink) NÃO disparam
      // leave — o timer se mantém cancelado.
      item.addEventListener("pointerenter", function () { openItem(item); });
      item.addEventListener("pointerleave", function () { scheduleClose(item); });

      // A11y: teclado e foco também abrem/fecham.
      item.addEventListener("focusin", function () { openItem(item); });
      item.addEventListener("focusout", function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose(item);
      });
      toggle.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          closeNow(item);
          toggle.blur();
        }
      });
    });
  })();
})();

// --- Desktop header: itens excedentes entram no dropdown "Mais" -----------
(function () {
  function initDesktopNavOverflow() {
    var nav = document.querySelector(".site-header__nav");
    var list = nav && nav.querySelector(".site-header__nav-list");
    var overflow = list && list.querySelector("[data-nav-overflow]");
    var overflowList = overflow && overflow.querySelector("[data-nav-overflow-list]");
    if (!nav || !list || !overflow || !overflowList) return;

    var items = Array.prototype.slice.call(list.children).filter(function (item) {
      return item !== overflow;
    });
    var resizeTimer = null;

    function resetOverflow() {
      items.forEach(function (item) {
        item.hidden = false;
        item.removeAttribute("aria-hidden");
      });
      overflow.hidden = true;
      overflow.classList.remove("is-open");
      var toggle = overflow.querySelector("[data-nav-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      overflowList.replaceChildren();
    }

    function appendOverflowLink(item) {
      var source = item.querySelector(":scope > .site-header__nav-link");
      if (!source) return;
      var row = document.createElement("li");
      var link = document.createElement("a");
      link.href = source.href;
      link.setAttribute("role", "menuitem");
      link.textContent = (source.querySelector("span") || source).textContent.trim();
      if (source.classList.contains("active")) link.classList.add("active");
      if (source.getAttribute("aria-current")) {
        link.setAttribute("aria-current", source.getAttribute("aria-current"));
      }
      row.appendChild(link);
      overflowList.prepend(row);
    }

    function fitNavigation() {
      resetOverflow();
      if (window.innerWidth < 1200) return;

      var available = Math.floor(nav.getBoundingClientRect().width);
      if (!available || list.scrollWidth <= available + 1) return;

      overflow.hidden = false;
      for (var index = items.length - 1; index >= 0 && list.scrollWidth > available + 1; index -= 1) {
        items[index].hidden = true;
        items[index].setAttribute("aria-hidden", "true");
        appendOverflowLink(items[index]);
      }
    }

    function scheduleFit() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(fitNavigation, 80);
    }

    fitNavigation();
    window.addEventListener("load", fitNavigation, { once: true });
    window.addEventListener("resize", scheduleFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNavigation);
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(scheduleFit);
      observer.observe(nav);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDesktopNavOverflow, { once: true });
  } else {
    initDesktopNavOverflow();
  }
})();

// --- Color swatch hex mapper (filtros de cor no Liquid) ---------------------
(function () {
  var ENTRIES = [
    ["Preto","#0f0f0f"],["Branco","#f5f4f0"],["Off White","#efece4"],["Off-white","#efece4"],
    ["Nude","#d9b79f"],["Nude Rose","#e2b8ae"],["Nude Rosé","#e2b8ae"],
    ["Rose","#e2b8ae"],["Rosé","#e2b8ae"],
    ["Bege","#d4b896"],["Bege Escuro","#a88a68"],
    ["Caramelo","#a26a3d"],["Chocolate","#5a3924"],["Marrom","#6b4226"],
    ["Marrom Cacau","#4a2d1e"],["Cacau","#4a2d1e"],["Café","#4b2e20"],["Cafe","#4b2e20"],
    ["Mel","#c68f3a"],["Mostarda","#c9a227"],["Terracota","#b1573b"],["Telha","#a54a2e"],
    ["Vermelho","#b3241d"],["Vinho","#5a1a24"],["Coral","#e26a5a"],
    ["Salmão","#e79c85"],["Salmao","#e79c85"],["Pêssego","#f0b494"],["Pessego","#f0b494"],
    ["Rosa Antigo","#c48a8a"],["Rosa Bebê","#f2c8cf"],["Rosa Bebe","#f2c8cf"],
    ["Rosa Chá","#e6c1b8"],["Rosa Cha","#e6c1b8"],["Rosa","#e59aad"],["Pink","#e0308f"],
    ["Lilás","#b9a3c9"],["Lilas","#b9a3c9"],["Roxo","#5d3a72"],["Uva","#4a2540"],
    ["Azul","#254a7a"],["Azul Marinho","#1c2a44"],["Marinho","#1c2a44"],
    ["Azul Bebê","#bcd3e3"],["Azul Bebe","#bcd3e3"],
    ["Azul Petróleo","#204b5a"],["Petroleo","#204b5a"],["Petróleo","#204b5a"],
    ["Turquesa","#3aa9a4"],["Verde","#3d6b46"],["Verde Militar","#4b5320"],["Militar","#4b5320"],
    ["Verde Oliva","#6b7b3a"],["Oliva","#6b7b3a"],["Verde Água","#b7e4d6"],["Verde Agua","#b7e4d6"],
    ["Amarelo","#e7c02a"],["Cinza","#8a8a8a"],["Cinza Mescla","#9c9c9c"],["Mescla","#9c9c9c"],
    ["Chumbo","#4a4d55"],["Grafite","#3a3a3a"],["Caqui","#a89473"],["Areia","#dcc9a6"],
    ["Champagne","#d9c9a3"],["Champanhe","#d9c9a3"]
  ];
  function norm(s) { return (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase().replace(/[^a-z0-9]+/g," ").trim(); }
  var MAP = {}; ENTRIES.forEach(function (p) { MAP[norm(p[0])] = p[1]; });
  function hexes(label) {
    var n = norm(label);
    if (MAP[n]) return [MAP[n]];
    var parts = n.split(/\s+e\s+|\s*[\/&]\s*|\s+/).filter(Boolean);
    var out = []; parts.forEach(function (p) { if (MAP[p]) out.push(MAP[p]); });
    return out;
  }
  function paint(el) {
    var h = hexes(el.getAttribute("data-color") || "");
    if (h.length === 0) return;
    if (h.length === 1) { el.style.background = h[0]; return; }
    var stops = h.map(function (c, i, a) {
      return c + " " + (i / a.length * 360) + "deg " + ((i + 1) / a.length * 360) + "deg";
    }).join(", ");
    el.style.background = "conic-gradient(" + stops + ")";
  }
  document.querySelectorAll(".filter-list__swatch[data-color]").forEach(paint);
})();

// ============================================================================
// Instant-apply filters (Section Rendering API)
// ============================================================================
(function () {
  "use strict";
  var raf = 0;
  function measureHeaderHeight() {
    raf = 0;
    var header = document.querySelector(".site-top");
    var height = header ? Math.ceil(header.getBoundingClientRect().height) : 101;
    if (!height || height < 48) height = 101;
    document.documentElement.style.setProperty("--header-h", height + "px");
    document.documentElement.style.setProperty("--site-top-h", height + "px");
  }
  function scheduleMeasure() {
    if (raf) return;
    raf = window.requestAnimationFrame(measureHeaderHeight);
  }
  window.SC = window.SC || {};
  window.SC.updateHeaderHeight = scheduleMeasure;
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scheduleMeasure);
  else scheduleMeasure();
  window.addEventListener("resize", scheduleMeasure, { passive: true });
  window.addEventListener("orientationchange", scheduleMeasure, { passive: true });
  window.addEventListener("scroll", scheduleMeasure, { passive: true });
  if (window.ResizeObserver) {
    var observer = new ResizeObserver(scheduleMeasure);
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        var header = document.querySelector(".site-top");
        if (header) observer.observe(header);
      });
    } else {
      var header = document.querySelector(".site-top");
      if (header) observer.observe(header);
    }
  }
})();

function initInstantFilters(root) {
  root = root || document;
  var sectionRoot = root.querySelector("[data-collection-root], [data-search-root]");
  if (!sectionRoot) return;
  var sectionId = sectionRoot.getAttribute("data-section-id");
  var form = sectionRoot.querySelector("[data-filter-panel]");
  var progress = sectionRoot.querySelector("[data-filters-progress]");
  var grid = sectionRoot.querySelector("[data-collection-grid]");

  // --- Left filter drawer (Skims-style) ---
  var drawer = sectionRoot.querySelector("[data-filter-drawer]");
  var openBtn = sectionRoot.querySelector("[data-filter-open]");
  if (drawer && openBtn) {
    drawer.classList.remove("preload");
    var openDrawer = function () {
      drawer.hidden = false;
      // Force reflow so the transition plays.
      void drawer.offsetWidth;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      openBtn.setAttribute("aria-expanded", "true");
      document.body.classList.add("body--drawer-open");
      var first = drawer.querySelector(".filter-drawer__close");
      if (first) first.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      openBtn.setAttribute("aria-expanded", "false");
      document.body.classList.remove("body--drawer-open");
      window.setTimeout(function () { drawer.hidden = true; }, 260);
      try { openBtn.focus(); } catch (e) {}
    };
    // Só expõe funções para os delegates globais abaixo. Não registrar listener
    // nos botões/drawer: a Section Rendering API troca este nó inteiro.
    sectionRoot.__openFilterDrawer = openDrawer;
    sectionRoot.__closeFilterDrawer = closeDrawer;
  }

  // Sort dropdown é delegado no document para sobreviver ao Section Rendering.

  if (!form || !sectionId) {
    // Fallback: sort auto-submit only
    var s = sectionRoot.querySelector("[data-filter-sort]");
    if (s && s.form) s.addEventListener("change", function () { s.form.submit(); });
    return;
  }

  var debounceTimer = null;
  var currentAbort = null;

  function buildTargetUrl() {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) {
      if (v === "" || v == null) return;
      params.append(k, v);
    });
    var base = window.location.pathname;
    var qs = params.toString();
    return qs ? base + "?" + qs : base;
  }

  function setBusy(on) {
    if (progress) progress.classList.toggle("is-active", !!on);
    if (grid) grid.classList.toggle("is-busy", !!on);
    var drw = sectionRoot.querySelector("[data-filter-drawer]");
    if (drw) drw.classList.toggle("is-busy", !!on);
  }

  async function commit() {
    var url = buildTargetUrl();
    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set("section_id", sectionId);
    if (currentAbort) currentAbort.abort();
    currentAbort = new AbortController();
    setBusy(true);
    try {
      var res = await fetch(fetchUrl.toString(), {
        headers: { Accept: "text/html" },
        signal: currentAbort.signal,
      });
      if (!res.ok) throw new Error("HTTP " + res.status);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var newRoot = doc.querySelector("[data-collection-root], [data-search-root]");
      if (!newRoot) throw new Error("no root");
      // Preserve open state of details panels
      var openIds = [];
      sectionRoot.querySelectorAll("details.filter-group[open]").forEach(function (d, i) { openIds.push(i); });
      var wasDrawerOpen = !!sectionRoot.querySelector("[data-filter-drawer].is-open");
      var drawerScrollTop = 0;
      var drawerBody = sectionRoot.querySelector(".filter-drawer__body");
      if (drawerBody) drawerScrollTop = drawerBody.scrollTop;
      sectionRoot.replaceWith(newRoot);
      newRoot.querySelectorAll("details.filter-group").forEach(function (d, i) {
        if (openIds.indexOf(i) >= 0) d.setAttribute("open", ""); else d.removeAttribute("open");
      });
      if (wasDrawerOpen) {
        var d2 = newRoot.querySelector("[data-filter-drawer]");
        var b2 = newRoot.querySelector("[data-filter-open]");
        if (d2) { d2.hidden = false; d2.classList.remove("preload"); d2.classList.add("is-open"); d2.setAttribute("aria-hidden", "false"); }
        if (b2) b2.setAttribute("aria-expanded", "true");
        document.body.classList.add("body--drawer-open");
        var nb2 = newRoot.querySelector(".filter-drawer__body");
        if (nb2) nb2.scrollTop = drawerScrollTop;
      }
      // Match React: after the swap, briefly hold the grid at busy-opacity
      // and release next frame so the browser animates the 120ms transition
      // (React keeps the same node and just toggles the class).
      var newGrid = newRoot.querySelector("[data-collection-grid]");
      if (newGrid) {
        newGrid.classList.add("is-busy");
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { newGrid.classList.remove("is-busy"); });
        });
      }
      // Update URL without full navigation
      window.history.replaceState(null, "", url);
      // Re-init on the new subtree
      initInstantFilters(document);
      if (window.SC && typeof window.SC.wireTileScrollers === "function") window.SC.wireTileScrollers();
      if (window.SC && typeof window.SC.updateHeaderHeight === "function") window.SC.updateHeaderHeight();
      if (window.initSwatches) window.initSwatches(newRoot);
      newRoot.querySelectorAll(".filter-list__swatch[data-color]").forEach(function (el) {
        el.dispatchEvent(new Event("swatch:repaint"));
      });
    } catch (err) {
      if (err && err.name === "AbortError") return;
      console.error("Filters refresh failed", err);
    } finally {
      setBusy(false);
    }
  }

  function schedule(delay) {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(commit, delay);
  }

  // Expose scheduler/setBusy for the document-level delegates below.
  sectionRoot.__filtersCommit = commit;
  sectionRoot.__filtersSchedule = schedule;
}

// ---------- Document-level delegation (survives Section Rendering swaps) ----------
// Bug pattern: `form.addEventListener` on a form that gets replaced by the
// Section Rendering API loses its handler on the SECOND click. Same family as
// the cart "+" and Okendo "Mostrar mais" regressions. Fix once, at document.
(function wireFilterDelegatesOnce() {
  if (document.__scFiltersDelegated) return;
  document.__scFiltersDelegated = true;

  function currentSection() {
    return document.querySelector("[data-collection-root], [data-search-root]");
  }
  function schedule(delay) {
    var s = currentSection();
    if (s && typeof s.__filtersSchedule === "function") s.__filtersSchedule(delay);
  }

  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest("[data-filter-panel]")) return;
    if (!(t.matches("[data-filter-input], [data-filter-sort]") || t.type === "checkbox" || t.type === "radio" || t.name === "sort_by")) return;
    schedule(t.type === "number" ? 350 : 250);
  }, true);

  document.addEventListener("input", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest("[data-filter-panel]")) return;
    if (t.type === "number") schedule(350);
  }, true);

  document.addEventListener("submit", function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches("[data-filter-panel]")) return;
    e.preventDefault();
    schedule(0);
  }, true);

  document.addEventListener("click", function (e) {
    var filterOpen = e.target.closest("[data-filter-open]");
    if (filterOpen) {
      var openSection = currentSection();
      if (!openSection || !openSection.contains(filterOpen) || typeof openSection.__openFilterDrawer !== "function") return;
      e.preventDefault();
      openSection.__openFilterDrawer();
      return;
    }

    var filterClose = e.target.closest("[data-filter-close], [data-filter-close-apply]");
    if (filterClose) {
      var closeSection = currentSection();
      if (!closeSection || !closeSection.contains(filterClose) || typeof closeSection.__closeFilterDrawer !== "function") return;
      e.preventDefault();
      closeSection.__closeFilterDrawer();
      return;
    }

    var trigger = e.target.closest("[data-sort-dropdown] .sort-dropdown__trigger");
    if (trigger) {
      var sortDD = trigger.closest("[data-sort-dropdown]");
      var section = currentSection();
      if (!section || !section.contains(sortDD)) return;
      e.preventDefault();
      var open = !sortDD.classList.contains("is-open");
      document.querySelectorAll("[data-sort-dropdown].is-open").forEach(function (dd) {
        dd.classList.remove("is-open");
        var btn = dd.querySelector(".sort-dropdown__trigger");
        if (btn) btn.setAttribute("aria-expanded", "false");
      });
      sortDD.classList.toggle("is-open", open);
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
      return;
    }

    var sortOption = e.target.closest("[data-sort-dropdown] [data-value]");
    if (sortOption) {
      var dd = sortOption.closest("[data-sort-dropdown]");
      var sSort = currentSection();
      if (!sSort || !sSort.contains(dd)) return;
      e.preventDefault();
      var value = sortOption.getAttribute("data-value");
      var label = sortOption.querySelector("span") ? sortOption.querySelector("span").textContent : value;
      var currentLabel = dd.querySelector("[data-sort-current]");
      var triggerBtn = dd.querySelector(".sort-dropdown__trigger");
      var radio = sSort.querySelector('input[name="sort_by"][value="' + CSS.escape(value) + '"]');
      var hidden = sSort.querySelector('input[name="sort_by"][type="hidden"], select[name="sort_by"]');
      if (currentLabel) currentLabel.textContent = label || value;
      dd.querySelectorAll("[data-value]").forEach(function (x) { x.setAttribute("aria-selected", x === sortOption ? "true" : "false"); });
      dd.classList.remove("is-open");
      if (triggerBtn) triggerBtn.setAttribute("aria-expanded", "false");
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      } else if (hidden) {
        hidden.value = value;
        hidden.dispatchEvent(new Event("change", { bubbles: true }));
      }
      return;
    }

    document.querySelectorAll("[data-sort-dropdown].is-open").forEach(function (dd) {
      if (dd.contains(e.target)) return;
      dd.classList.remove("is-open");
      var btn = dd.querySelector(".sort-dropdown__trigger");
      if (btn) btn.setAttribute("aria-expanded", "false");
    });

    var a = e.target.closest("a.chip, a.chip--clear, a.chip--in-drawer, a.pagination__nav, a.pagination__page, [data-filter-chip]");
    if (!a) return;
    var s = currentSection();
    if (!s || !s.contains(a)) return;
    var href = a.getAttribute("href");
    if (!href) return;
    e.preventDefault();
    (async function () {
      var sectionId = s.getAttribute("data-section-id");
      var drw = s.querySelector("[data-filter-drawer]");
      if (drw) drw.classList.add("is-busy");
      var grid = s.querySelector("[data-collection-grid]");
      if (grid) grid.classList.add("is-busy");
      try {
        var fetchUrl = new URL(href, window.location.origin);
        fetchUrl.searchParams.set("section_id", sectionId);
        var res = await fetch(fetchUrl.toString(), { headers: { Accept: "text/html" } });
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newRoot = doc.querySelector("[data-collection-root], [data-search-root]");
        if (!newRoot) throw new Error("no root");
        var wasOpen = !!s.querySelector("[data-filter-drawer].is-open");
        var openIds = [];
        s.querySelectorAll("details.filter-group[open]").forEach(function (d, i) { openIds.push(i); });
        var scrollTop = 0;
        var body = s.querySelector(".filter-drawer__body");
        if (body) scrollTop = body.scrollTop;
        s.replaceWith(newRoot);
        newRoot.querySelectorAll("details.filter-group").forEach(function (d, i) {
          if (openIds.indexOf(i) >= 0) d.setAttribute("open", ""); else d.removeAttribute("open");
        });
        if (wasOpen) {
          var d2 = newRoot.querySelector("[data-filter-drawer]");
          var b2 = newRoot.querySelector("[data-filter-open]");
          if (d2) { d2.hidden = false; d2.classList.remove("preload"); d2.classList.add("is-open"); d2.setAttribute("aria-hidden", "false"); }
          if (b2) b2.setAttribute("aria-expanded", "true");
          document.body.classList.add("body--drawer-open");
          var nb = newRoot.querySelector(".filter-drawer__body");
          if (nb) nb.scrollTop = scrollTop;
        }
        window.history.replaceState(null, "", href);
        initInstantFilters(document);
        if (window.SC && typeof window.SC.wireTileScrollers === "function") window.SC.wireTileScrollers();
        if (window.SC && typeof window.SC.updateHeaderHeight === "function") window.SC.updateHeaderHeight();
        if (window.initSwatches) window.initSwatches(newRoot);
        if (a.matches("a.pagination__nav, a.pagination__page")) window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
        console.error("Filter chip apply failed", err);
      } finally {
        var s2 = currentSection();
        if (s2) {
          var g = s2.querySelector("[data-collection-grid]");
          if (g) g.classList.remove("is-busy");
          var d = s2.querySelector("[data-filter-drawer]");
          if (d) d.classList.remove("is-busy");
        }
      }
    })();
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var s = currentSection();
    var drawer = s && s.querySelector("[data-filter-drawer].is-open");
    if (drawer && typeof s.__closeFilterDrawer === "function") s.__closeFilterDrawer();
  });
})();

// ============================================================================
// Category tile navigation — Section Rendering API, sem recarregar a página
// ----------------------------------------------------------------------------
// - Os tiles continuam sendo <a href> reais (SEO, abrir em nova aba, cmd+click).
//   Só interceptamos clique primário sem modificador; qualquer teclado especial
//   ou botão do meio devolve o controle ao browser.
// - Reusa a MESMA pipeline dos chips: fetch(?section_id=X) e replaceWith.
// - pushState + popstate para voltar/avançar funcionarem.
// - Preservação de filtros PREFERÊNCIA (sort, in-stock, tamanho, cor) é
//   centralizada em `SC.tilePreserve` (mesma função reescreve os <a href>
//   dos tiles no load e monta a URL do swap). Preço é sempre descartado.
//   Valores que não existirem na categoria de destino são removidos da URL
//   com aviso discreto acima da grade — pruneUnknownsAndNotify().
// - Falha de rede → window.location = href (navegação normal, jamais fica presa).
// - Delegação no document — sobrevive à substituição do <section>.
// ============================================================================
// ---------------------------------------------------------------------------
// SC.tilePreserve — regra ÚNICA de preservação de filtros entre categorias.
// Usada tanto na reescrita dos <a href> dos tiles quanto no swap via Section
// Rendering API. Se mudar a política, muda AQUI, num lugar só.
// ---------------------------------------------------------------------------
(function tilePreserveApi() {
  window.SC = window.SC || {};
  if (window.SC.tilePreserve) return;

  // Preservar SEMPRE (preferência da pessoa, não da categoria).
  //  - sort_by
  //  - filter.v.availability (só em estoque)
  //  - filter.v.option.tamanho / .size (tamanho é atributo do corpo)
  function isAlwaysKeep(name) {
    if (name === "sort_by") return true;
    if (name === "filter.v.availability") return true;
    if (/^filter\.v\.option\.(tamanho|size)$/i.test(name)) return true;
    return false;
  }
  // Preservar SE EXISTIR no destino (cor e demais atributos/tags/vendor).
  function isKeepIfPresent(name) {
    if (isAlwaysKeep(name)) return false;
    if (/^filter\.v\.price\./.test(name)) return false; // preço descarta sempre
    return /^filter\./.test(name);
  }
  function isPreservableAtSource(name) {
    return isAlwaysKeep(name) || isKeepIfPresent(name);
  }

  // Snapshot dos rótulos legíveis dos filtros ativos, para o aviso na chegada.
  // Faz par (name|value) → label a partir dos inputs do drawer.
  function snapshotLabels() {
    try {
      var map = {};
      document.querySelectorAll("[data-filter-input]").forEach(function (inp) {
        var name = inp.getAttribute("name");
        var value = inp.getAttribute("value");
        if (!name || !value) return;
        var lbl = inp.closest("label");
        var text = "";
        if (lbl) {
          var span = lbl.querySelector(".filter-list__label, .filter-swatch__label, .filter-size__label");
          text = (span ? span.textContent : lbl.textContent) || "";
        }
        text = text.replace(/\s+/g, " ").trim();
        if (!text) text = value;
        map[name + "|" + value] = text;
      });
      // Rótulos do grupo do filtro (ex. "Cor", "Tamanho"), por name.
      var groups = {};
      document.querySelectorAll("[data-filter-panel] .filter-group, [data-filter-panel] details").forEach(function (grp) {
        var head = grp.querySelector(".filter-group__label, summary");
        var input = grp.querySelector("[data-filter-input][name]");
        if (head && input) {
          var nm = input.getAttribute("name");
          if (nm && !groups[nm]) groups[nm] = (head.textContent || "").replace(/\s+/g, " ").trim();
        }
      });
      sessionStorage.setItem("sc:filter-labels", JSON.stringify({ values: map, groups: groups }));
    } catch (_) { /* sessionStorage indisponível — degradação aceitável */ }
  }
  function readLabels() {
    try {
      var raw = sessionStorage.getItem("sc:filter-labels");
      return raw ? JSON.parse(raw) : { values: {}, groups: {} };
    } catch (_) { return { values: {}, groups: {} }; }
  }

  // Recebe um URL de destino (mesmo host, /collections/*) e devolve outro URL
  // com os params preserváveis herdados da URL atual (sem sobrescrever o que
  // o próprio href já traz — improvável, mas seguro).
  function decorate(destUrl, sourceSearchStr) {
    var src = new URLSearchParams(sourceSearchStr || window.location.search);
    src.forEach(function (val, key) {
      if (!isPreservableAtSource(key)) return;
      if (destUrl.searchParams.has(key)) return;
      destUrl.searchParams.append(key, val);
    });
    return destUrl;
  }

  // Reescreve <a class="subcollection-tile" href="/collections/..."> na página
  // atual acrescentando os params preserváveis. É acréscimo — o href continua
  // sendo um link real (SEO, nova aba, sem-JS).
  function rewriteAllTiles(root) {
    var scope = root || document;
    var srcSearch = window.location.search;
    scope.querySelectorAll("a.subcollection-tile[href]").forEach(function (a) {
      var raw = a.getAttribute("href");
      if (!raw) return;
      var url;
      try { url = new URL(raw, window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin) return;
      if (!/^\/collections\//.test(url.pathname)) return;
      // Preserva um marcador do href "cru" para não empilhar reescritas.
      if (!a.dataset.originalHref) a.dataset.originalHref = raw;
      var base = new URL(a.dataset.originalHref, window.location.origin);
      decorate(base, srcSearch);
      a.setAttribute("href", base.pathname + (base.search || ""));
    });
  }

  // Após a chegada (load ou pós-swap), remove da URL os filtros que não
  // existem no destino (exceto os "always keep") e mostra aviso discreto.
  function pruneUnknownsAndNotify(sectionRoot) {
    var section = sectionRoot || document.querySelector("[data-collection-root]");
    if (!section) return;
    // Coleta (name|value) disponíveis no drawer do destino.
    var avail = new Set();
    section.querySelectorAll("[data-filter-input][name][value]").forEach(function (inp) {
      avail.add(inp.getAttribute("name") + "|" + inp.getAttribute("value"));
    });

    var url = new URL(window.location.href);
    var labels = readLabels();
    var removed = []; // [{ name, value, groupLabel, valueLabel }]
    // Itera sobre uma cópia — vamos mutar durante o laço.
    Array.from(url.searchParams.entries()).forEach(function (pair) {
      var name = pair[0], value = pair[1];
      if (!/^filter\./.test(name)) return;
      if (isAlwaysKeep(name)) return; // regra: nunca soltar
      if (avail.size === 0) return;    // sem drawer no destino — não julgar
      if (avail.has(name + "|" + value)) return;
      url.searchParams.delete(name);
      // Se veio múltiplo, remove apenas ESTE valor. URLSearchParams.delete tira todos;
      // repõe os demais.
      // (Rara ocorrência, mas correta.)
      var kept = (new URLSearchParams(window.location.search)).getAll(name).filter(function (v) { return v !== value; });
      kept.forEach(function (v) { url.searchParams.append(name, v); });
      removed.push({
        name: name,
        value: value,
        groupLabel: labels.groups && labels.groups[name] ? labels.groups[name] : "",
        valueLabel: labels.values && labels.values[name + "|" + value]
          ? labels.values[name + "|" + value]
          : value.replace(/-/g, " "),
      });
    });

    if (removed.length === 0) return;

    // Atualiza a URL SEM recarregar — reflete o estado real (regra: nada de
    // estado escondido em JS).
    var clean = url.pathname + (url.search ? url.search : "") + (url.hash || "");
    window.history.replaceState(window.history.state || {}, "", clean);

    // Renderiza aviso acima da grade. Insere no topo do sectionRoot.
    var host = section.querySelector(".collection-hero") || section.firstElementChild || section;
    var box = document.createElement("div");
    box.className = "tile-nav-notice";
    box.setAttribute("role", "status");
    var msgs = removed.map(function (r) {
      var g = r.groupLabel ? (r.groupLabel + ": ") : "";
      return "Removemos o filtro " + g + r.valueLabel + ", indisponível nesta categoria.";
    });
    box.textContent = msgs.join(" ");
    host.parentNode.insertBefore(box, host.nextSibling);
    // Auto-hide depois de 8s (aviso é discreto, não persistente).
    setTimeout(function () { if (box && box.parentNode) box.parentNode.removeChild(box); }, 8000);
  }

  window.SC.tilePreserve = {
    isAlwaysKeep: isAlwaysKeep,
    isKeepIfPresent: isKeepIfPresent,
    snapshotLabels: snapshotLabels,
    decorate: decorate,
    rewriteAllTiles: rewriteAllTiles,
    pruneUnknownsAndNotify: pruneUnknownsAndNotify,
  };

  // Boot: ao carregar uma página de coleção, reescreve os tiles e, se viemos
  // de outro tile, aplica prune + aviso. Flag `sc:tile-nav` é setada no clique.
  function boot() {
    if (!document.querySelector("[data-collection-root]")) return;
    rewriteAllTiles(document);
    try {
      if (sessionStorage.getItem("sc:tile-nav") === "1") {
        pruneUnknownsAndNotify();
        sessionStorage.removeItem("sc:tile-nav");
      }
    } catch (_) {}
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

(function wireTileNavOnce() {
  if (document.__scTileNavDelegated) return;
  document.__scTileNavDelegated = true;

  function currentCollectionSection() {
    return document.querySelector("[data-collection-root]");
  }

  function scrollGridIntoView(newRoot) {
    // Rola para o topo da GRADE (não da página). A pessoa está olhando a
    // fileira de tiles logo acima — jogá-la pro header é desorientador.
    var target = newRoot.querySelector("[data-collection-grid]")
              || newRoot.querySelector(".subcollection-scroller")
              || newRoot;
    if (!target) return;
    var headerH = 0;
    var st = document.querySelector(".site-top");
    if (st) headerH = st.getBoundingClientRect().height;
    var y = target.getBoundingClientRect().top + window.scrollY - headerH - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
  }

  async function swapCollectionSection(href, opts) {
    opts = opts || {};
    var section = currentCollectionSection();
    if (!section) throw new Error("no section");
    var sectionId = section.getAttribute("data-section-id");
    var grid = section.querySelector("[data-collection-grid]");
    var spinnerTimer = 0;

    section.setAttribute("aria-busy", "true");
    if (grid) grid.classList.add("is-busy");
    // Só mostra a barrinha de progresso se demorar > 200ms — abaixo disso pisca.
    var progress = section.querySelector("[data-filters-progress]");
    if (progress) {
      spinnerTimer = window.setTimeout(function () {
        progress.classList.add("is-active");
      }, 200);
    }

    try {
      // Preservação centralizada em SC.tilePreserve (mesma função da reescrita
      // de <a href>). Regra: sort_by, availability e tamanho sempre; cor/outros
      // se existirem no destino; preço descarta sempre.
      var url = new URL(href, window.location.origin);
      if (window.SC && window.SC.tilePreserve) {
        window.SC.tilePreserve.decorate(url, window.location.search);
      }
      var cleanHref = url.pathname + (url.search || "");

      var fetchUrl = new URL(url.toString(), window.location.origin);
      fetchUrl.searchParams.set("section_id", sectionId);

      var res = await fetch(fetchUrl.toString(), {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
      });
      if (!res.ok) throw new Error("HTTP " + res.status);
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var newRoot = doc.querySelector("[data-collection-root]");
      if (!newRoot) throw new Error("no root");

      section.replaceWith(newRoot);

      // Atualiza o <title> (a resposta section_id não traz <title>, tudo bem —
      // caímos no que o Liquid renderizou para o <h1>).
      var newTitle = newRoot.querySelector(".collection-hero__title");
      if (newTitle && newTitle.textContent) {
        document.title = newTitle.textContent.trim();
      }

      if (opts.push !== false) {
        window.history.pushState({ scCollectionSwap: true }, "", cleanHref);
      }

      // Reboot pipelines: filters + swatches + tiles (dragging + centerActive).
      if (typeof initInstantFilters === "function") initInstantFilters(document);
      if (window.initSwatches) window.initSwatches(newRoot);
      if (window.consolidateFilters) window.consolidateFilters(newRoot);
      if (window.SC && typeof window.SC.wireTileScrollers === "function") {
        window.SC.wireTileScrollers();
      }
      if (window.SC && typeof window.SC.updateHeaderHeight === "function") {
        window.SC.updateHeaderHeight();
      }
      // Pós-swap: reescreve tiles do novo subtree e aplica prune+aviso.
      if (window.SC && window.SC.tilePreserve) {
        window.SC.tilePreserve.rewriteAllTiles(newRoot);
        window.SC.tilePreserve.pruneUnknownsAndNotify(newRoot);
        try { sessionStorage.removeItem("sc:tile-nav"); } catch (_) {}
      }
      // O prefetch-nav escuta este evento pra re-observar cards do subtree novo.
      document.dispatchEvent(new CustomEvent("collection:updated"));

      scrollGridIntoView(newRoot);

      newRoot.setAttribute("aria-busy", "false");
      return newRoot;
    } finally {
      if (spinnerTimer) window.clearTimeout(spinnerTimer);
      var pAny = document.querySelector("[data-collection-root] [data-filters-progress]");
      if (pAny) pAny.classList.remove("is-active");
      var s2 = currentCollectionSection();
      if (s2) {
        s2.setAttribute("aria-busy", "false");
        var g2 = s2.querySelector("[data-collection-grid]");
        if (g2) g2.classList.remove("is-busy");
      }
    }
  }

  document.addEventListener("click", function (e) {
    // Só clique primário. Deixa cmd/ctrl/shift/alt/meio abrirem em nova aba.
    if (e.defaultPrevented) return;
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest && e.target.closest("a.subcollection-tile[href]");
    if (!a) return;
    // Só quando estamos NUMA página de coleção (com data-collection-root).
    // Fora daí (por ex. home), deixa a navegação normal.
    if (!currentCollectionSection()) return;
    var href = a.getAttribute("href");
    if (!href) return;
    // Se o href não é uma URL de coleção do mesmo host, deixa passar.
    try {
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return;
      if (!/^\/collections\//.test(url.pathname)) return;
    } catch (_) { return; }

    // Snapshot dos rótulos ANTES de sair — precisamos deles pro aviso na chegada.
    // Flag "veio de tile" permite prune+aviso mesmo em fallback full-nav.
    try {
      if (window.SC && window.SC.tilePreserve) window.SC.tilePreserve.snapshotLabels();
      sessionStorage.setItem("sc:tile-nav", "1");
    } catch (_) {}

    e.preventDefault();
    swapCollectionSection(href, { push: true }).catch(function (err) {
      // Fallback duro: navegação normal. Nunca deixar a pessoa presa.
      console.warn("Tile swap fallback → full nav", err);
      window.location.assign(href);
    });
  });

  window.addEventListener("popstate", function () {
    if (!currentCollectionSection()) return;
    if (!/^\/collections\//.test(window.location.pathname)) return;
    swapCollectionSection(window.location.pathname + window.location.search, { push: false })
      .catch(function () { window.location.reload(); });
  });
})();

// ============================================================================
// Home tile scrollers — drag-to-scroll + keyboard
// ============================================================================
(function () {
  "use strict";
  var THRESH = 5;
  var shortcutScrollers = new Set();
  var shortcutObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { if (entry.target.updateShortcutArrows) entry.target.updateShortcutArrows(); });
  });
  function wire(el) {
    if (el.dataset.tileWired === "1") return;
    el.dataset.tileWired = "1";
    if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "0");
    var startX = 0, startScroll = 0, dragging = false, moved = false, pid = null;
    el.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return; // scroll nativo cuida
      if (e.button !== 0) return;
      dragging = true; moved = false;
      startX = e.clientX; startScroll = el.scrollLeft; pid = e.pointerId;
    });
    el.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > THRESH) {
        moved = true;
        el.classList.add("is-dragging");
        // Só captura o ponteiro DEPOIS do limiar: se não houve arrasto, o
        // clique fica dirigido ao <a> real (sem captura ele iria pro scroller).
        try { el.setPointerCapture(pid); } catch (_) {}
      }
      if (moved) { e.preventDefault(); el.scrollLeft = startScroll - dx; }
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      if (moved) {
        try { el.releasePointerCapture(pid); } catch (_) {}
        el.classList.remove("is-dragging");
        // Engolir o click sintético que segue o drag para não navegar sem querer.
        var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        el.addEventListener("click", swallow, { capture: true, once: true });
        setTimeout(function () { el.removeEventListener("click", swallow, true); }, 100);
      }
    }
    el.addEventListener("pointerup", end);
    el.addEventListener("pointercancel", end);
    el.addEventListener("pointerleave", function () { if (!moved) end(); });
    el.addEventListener("dragstart", function (e) { e.preventDefault(); });
    el.addEventListener("keydown", function (e) {
      var step = Math.max(120, el.clientWidth * 0.8);
      if (e.key === "ArrowRight") { el.scrollBy({ left: step, behavior: "smooth" }); e.preventDefault(); }
      if (e.key === "ArrowLeft")  { el.scrollBy({ left: -step, behavior: "smooth" }); e.preventDefault(); }
    });
    if (el.classList.contains("collection-shortcuts__scroll")) {
      var group = el.closest(".collection-shortcuts__group");
      var previous = group.querySelector("[data-shortcut-prev]");
      var next = group.querySelector("[data-shortcut-next]");
      var motion = function () { return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"; };
      el.updateShortcutArrows = function () {
        var overflow = el.scrollWidth > group.clientWidth + 2;
        previous.hidden = next.hidden = !overflow;
        previous.disabled = el.scrollLeft <= 2;
        next.disabled = el.scrollLeft >= el.scrollWidth - el.clientWidth - 2;
      };
      previous.addEventListener("click", function () { el.scrollBy({left:-el.clientWidth * .8, behavior:motion()}); });
      next.addEventListener("click", function () { el.scrollBy({left:el.clientWidth * .8, behavior:motion()}); });
      el.addEventListener("scroll", el.updateShortcutArrows, {passive:true});
      el.addEventListener("keydown", function (e) {
        if (e.target !== el || (e.key !== "Home" && e.key !== "End")) return;
        e.preventDefault();
        el.scrollTo({left:e.key === "Home" ? 0 : el.scrollWidth, behavior:motion()});
      });
      shortcutScrollers.add(el);
      shortcutObserver.observe(el);
      el.updateShortcutArrows();
    }
  }
  function centerActive(el) {
    if (!el.hasAttribute("data-scroll-active")) return;
    var active = el.querySelector("[data-active]");
    if (!active) return;
    var elRect = el.getBoundingClientRect();
    var aRect = active.getBoundingClientRect();
    var delta = (aRect.left - elRect.left) - (el.clientWidth / 2 - active.clientWidth / 2);
    el.scrollLeft += delta;
  }
  function boot() {
    shortcutScrollers.forEach(function (el) {
      if (!el.isConnected) { shortcutObserver.unobserve(el); shortcutScrollers.delete(el); }
    });
    document.querySelectorAll("[data-tile-scroller], .tile-scroller").forEach(function (el) {
      wire(el);
      centerActive(el);
    });
  }
  // Exposto para re-wire após Section Rendering trocar o subtree.
  window.SC = window.SC || {};
  window.SC.wireTileScrollers = boot;
  document.addEventListener("shopify:section:load", boot);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

/* Newsletter: submit lock (evita duplo envio). Delegação global. */
(function () {
  if (window.__scNewsletterDelegated) return;
  window.__scNewsletterDelegated = true;
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches("form[data-newsletter-form]")) return;
    var btn = form.querySelector("[data-newsletter-submit]");
    if (!btn || btn.disabled) return;
    btn.dataset.originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Enviando…";
  }, true);
  // Se o form estiver marcado como sucesso (posted), scroll suave até a mensagem
  var ok = document.querySelector(".newsletter__ok");
  if (ok && /customer_posted=true/.test(location.search)) {
    try { ok.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (_) {}
  }
})();

/* ==========================================================================
 * Notify-me (PDP) — "Me avise quando chegar"
 *
 * Regras (ver comentário do snippet snippets/pdp-notify-modal.liquid):
 *   - Envia SEMPRE 4 tags: newsletter, avisar, avisar:<variantId>:<AAAAMMDD>,
 *     avisar-tel:55<DDD><NUMERO>.
 *   - `contact[accepts_marketing]` = true, sempre. Sem checkbox no modal.
 *   - Telefone é a ÚNICA fonte de verdade para o sistema externo de SMS.
 *     Normalização: só dígitos; 10/11 dígitos → prefixa 55; 12/13 começando
 *     em 55 → mantém; qualquer outro tamanho → erro de validação.
 *   - Delegação registrada no `document` (container estável) — sobrevive a
 *     Section Rendering API repintando a buy box (Regra #5 do projeto).
 * ========================================================================== */
(function notifyModal() {
  if (window.__scNotifyDelegated) return;
  window.__scNotifyDelegated = true;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function getModal() { return q('[data-modal="notify"]'); }
  function todayYMD() {
    var d = new Date();
    var y = d.getUTCFullYear();
    var m = String(d.getUTCMonth() + 1).padStart(2, "0");
    var day = String(d.getUTCDate()).padStart(2, "0");
    return "" + y + m + day;
  }
  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  // Ver normalização documentada no snippet.
  function normalizePhoneBR(raw) {
    var digits = String(raw || "").replace(/\D+/g, "");
    if (digits.length === 10 || digits.length === 11) return "55" + digits;
    if ((digits.length === 12 || digits.length === 13) && digits.slice(0, 2) === "55") return digits;
    return null;
  }
  function showError(modal, msg) {
    var el = q("[data-notify-error]", modal);
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }
  function clearError(modal) {
    var el = q("[data-notify-error]", modal);
    if (el) { el.textContent = ""; el.hidden = true; }
  }
  function openModal(triggerBtn) {
    var modal = getModal();
    if (!modal) return;
    var ctxEl = q("[data-notify-ctx]", modal);
    var pdp = document.querySelector("[data-pdp]");
    // Contexto: título do produto + tamanho/cor selecionados (data-attrs no pdp)
    var title = (pdp && pdp.getAttribute("data-product-title")) || document.title;
    var variantLabel = (triggerBtn && triggerBtn.getAttribute("data-variant-label")) || "";
    // Shopify usa " / " entre opções (ex: "Preto / M"). Trocamos por " · "
    // para o modal exibir "Produto — Preto · M" — mais legível e é o formato
    // que o Brenno aprovou. Nenhum consumidor externo lê esta string.
    if (variantLabel) variantLabel = variantLabel.split(" / ").join(" · ");
    if (ctxEl) ctxEl.textContent = variantLabel ? (title + " — " + variantLabel) : title;
    // Stash para compor a mensagem de sucesso (produto + tamanho/cor).
    modal.dataset.productTitle = title || "";
    modal.dataset.variantLabel = variantLabel || "";
    // Stash variantId no modal: em LP com hero sold_out não há form de cart-add
    // no DOM, então o submit não conseguiria descobrir a variante por si só.
    var triggerVariantId = (triggerBtn && triggerBtn.getAttribute("data-variant-id")) || "";
    if (triggerVariantId) {
      modal.dataset.variantId = String(triggerVariantId).replace(/\D+/g, "");
    } else {
      delete modal.dataset.variantId;
    }
    clearError(modal);
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    SC.bodyLock.lock();
    attachViewportTracker(modal);
    var email = q("[data-notify-email]", modal);
    if (email) setTimeout(function () { try { email.focus(); } catch (_) {} }, 60);
  }
  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    if (!modal.hidden) {
      SC.bodyLock.unlock();
      detachViewportTracker(modal);
    }
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    var ok = q("[data-notify-ok]", modal);
    if (ok) {
      ok.hidden = true;
      var okMsg = q("[data-notify-ok-msg]", ok);
      if (okMsg) okMsg.textContent = "";
    }
    var form = q("[data-notify-form]", modal);
    if (form) {
      form.hidden = false;
      try { form.reset(); } catch (_) {}
    }
    // Reseta estado do submit em curso — o próximo open começa limpo.
    if (window.__scNotifyPending) {
      window.__scNotifyPending = false;
      if (window.__scNotifyTimeout) {
        clearTimeout(window.__scNotifyTimeout);
        window.__scNotifyTimeout = null;
      }
    }
    var submitBtn = q("[data-notify-submit]", modal);
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = "Quero ser avisada"; }
  }

  /* visualViewport: quando o teclado do iOS abre, a janela visível
     encolhe. Ancoramos o painel na área visível (bottom-sheet no mobile)
     para o campo focado e o botão continuarem acima do teclado. */
  var _vpHandler = null;
  function attachViewportTracker(modal) {
    var vp = window.visualViewport;
    if (!vp) return;
    var panel = q(".notify-modal__panel", modal);
    if (!panel) return;
    _vpHandler = function () {
      var h = Math.round(vp.height);
      panel.style.maxHeight = h + "px";
      if (window.innerWidth <= 640) {
        // bottom-sheet: cola no fundo da área visível
        var offset = Math.max(0, (window.innerHeight - h - vp.offsetTop));
        modal.style.paddingBottom = offset + "px";
      }
    };
    vp.addEventListener("resize", _vpHandler);
    vp.addEventListener("scroll", _vpHandler);
    _vpHandler();
  }
  function detachViewportTracker(modal) {
    var vp = window.visualViewport;
    if (vp && _vpHandler) {
      vp.removeEventListener("resize", _vpHandler);
      vp.removeEventListener("scroll", _vpHandler);
    }
    _vpHandler = null;
    var panel = q(".notify-modal__panel", modal);
    if (panel) panel.style.maxHeight = "";
    modal.style.paddingBottom = "";
  }

  // Delegação — abre e fecha
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var openBtn = t.closest("[data-open-notify]");
    if (openBtn) { e.preventDefault(); openModal(openBtn); return; }
    if (t.closest("[data-notify-close]")) { e.preventDefault(); closeModal(); return; }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var m = getModal();
      if (m && !m.hidden) closeModal();
    }
  });

  /* Iframe sink — sucesso = `onLoad` DEPOIS do submit.
     Guarda: `__scNotifyPending` só vira true quando o submit é disparado
     por nós; o load inicial (iframe em branco no primeiro parse) não
     conta como sucesso. Mesma guarda usada no React (status === "sending").
     Registrado uma única vez — se o snippet reaparecer via SRA, o
     iframe fica no mesmo container e o listener sobrevive. */
  function bindSink() {
    var sink = document.querySelector('[data-notify-sink]');
    if (!sink || sink.__scBound) return;
    sink.__scBound = true;
    sink.addEventListener("load", function () {
      if (!window.__scNotifyPending) return; // ignora load inicial
      window.__scNotifyPending = false;
      if (window.__scNotifyTimeout) {
        clearTimeout(window.__scNotifyTimeout);
        window.__scNotifyTimeout = null;
      }
      var modal = getModal();
      if (!modal) return;
      showSuccess(modal);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindSink, { once: true });
  } else {
    bindSink();
  }

  function showSuccess(modal) {
    var form = q("[data-notify-form]", modal);
    var okEl = q("[data-notify-ok]", modal);
    var okMsg = okEl && q("[data-notify-ok-msg]", okEl);
    var emailInput = q("[data-notify-email]", modal);
    var email = (emailInput && emailInput.value || "").trim();
    var title = (modal.dataset && modal.dataset.productTitle) || "esta peça";
    var variantLabel = (modal.dataset && modal.dataset.variantLabel) || "";
    // Sem prazo: o disparador ainda não existe. Confirmação factual só.
    var msg = "Avisaremos você em " + email + " assim que a " + title +
              (variantLabel ? " — " + variantLabel : "") + " voltar ao estoque.";
    if (okMsg) okMsg.textContent = msg;
    if (okEl) okEl.hidden = false;
    if (form) form.hidden = true;
    var submitBtn = q("[data-notify-submit]", modal);
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = "Quero ser avisada"; }
  }

  // Delegação — submit (nativo via iframe; sem preventDefault/fetch)
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches("[data-notify-form]")) return;
    var modal = getModal();
    if (!modal) return;
    clearError(modal);

    var emailInput = q("[data-notify-email]", modal);
    var phoneInput = q("[data-notify-phone]", modal);
    var tagsInput = q("[data-notify-tags]", modal);
    var submitBtn = q("[data-notify-submit]", modal);

    var email = (emailInput && emailInput.value || "").trim();
    if (!isValidEmail(email)) {
      e.preventDefault();
      showError(modal, "Confira o e-mail e tente novamente.");
      return;
    }
    var phoneNorm = normalizePhoneBR(phoneInput && phoneInput.value);
    if (!phoneNorm) {
      e.preventDefault();
      showError(modal, "Confira o telefone (DDD + número).");
      return;
    }

    // Descobre o variantId — prioridade: trigger (LP hero sold_out) > form de cart-add (PDP).
    var variantId = (modal.dataset && modal.dataset.variantId) || "";
    if (!variantId) {
      var pdpForm = document.querySelector("form[action$='/cart/add']");
      variantId = (pdpForm && pdpForm.querySelector('[name="id"]') && pdpForm.querySelector('[name="id"]').value) || "";
    }
    variantId = String(variantId || "").replace(/\D+/g, "");
    if (!variantId) {
      e.preventDefault();
      showError(modal, "Variante inválida. Recarregue a página e tente de novo.");
      return;
    }

    // 4 tags — formato EXATO documentado no snippet.
    var tags = [
      "newsletter",
      "avisar",
      "avisar:" + variantId + ":" + todayYMD(),
      "avisar-tel:" + phoneNorm,
    ].join(",");
    if (tagsInput) tagsInput.value = tags;

    // Submit NATIVO — target="notify-sink" no {% form %}. NÃO chamamos
    // preventDefault: o browser posta o form no iframe e o `load` do
    // iframe (guardado por __scNotifyPending) sinaliza sucesso.
    // Nenhum fetch. Nenhuma leitura de status. A classe inteira de
    // erro (302 / opaqueredirect / HTML) some porque não tocamos na
    // resposta.
    bindSink(); // idempotente — garante listener antes do POST
    window.__scNotifyPending = true;
    if (window.__scNotifyTimeout) clearTimeout(window.__scNotifyTimeout);
    // NÃO existe timeout declarando falha aqui — e isso é deliberado.
    //
    // O hCaptcha do Shopify (ce_storefront_forms_captcha_hcaptcha.iife.js)
    // intercepta o submit de TODO {% form 'customer' %}: chama preventDefault,
    // roda o desafio e re-submete o form por conta própria depois. Medido no
    // tema servido — a pilha de preventDefault aponta direto para esse script
    // (scripts/qa/notify-probe.mjs reproduz).
    //
    // O timeout antigo de 8s não distinguia "falhou" de "captcha ainda
    // rodando", então quando o desafio passava de 8s ele mostrava erro
    // ENQUANTO a submissão seguia a caminho: o Shopify gravava o cliente e a
    // usuária via mensagem de falha. Era exatamente o sintoma relatado
    // ("grava certo e mostra erro") — causado pelo próprio timer, não pela
    // resposta. Qualquer prazo fixo reintroduz o bug, porque o tempo do
    // desafio não tem teto conhecido.
    //
    // Sem prazo: o botão fica em "Enviando…" até o `load` do iframe confirmar.
    // Custo aceito: numa falha real de rede o botão não volta sozinho — o
    // fechar/reabrir do modal reseta o estado (ver closeModal). Preferimos
    // isso a mentir dizendo que falhou quando gravou.
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Enviando…"; }
  }, true);
})();

/* ============ Descrição da coleção: clamp + "Ler mais" ============
   O clamp é 100% CSS (2 linhas mobile / 3 desktop) e o texto completo
   permanece no DOM (SEO). Este script apenas revela o botão quando há
   overflow real, e alterna o estado via classe `.is-expanded`. Nunca
   remove nem edita o conteúdo. Delegação no `document` para sobreviver
   a re-renders da grade via Section Rendering API — o hero fica fora
   do container substituído, mas registramos no container estável para
   blindar contra qualquer redesenho futuro. */
(function () {
  function evaluateClamps() {
    document.querySelectorAll("[data-desc-clamp]").forEach(function (wrap) {
      var body = wrap.querySelector("[data-desc-body]");
      var btn = wrap.querySelector("[data-desc-toggle]");
      if (!body || !btn) return;
      // Só medimos no estado colapsado — expandido não tem overflow por definição.
      if (wrap.classList.contains("is-expanded")) return;
      var overflows = body.scrollHeight - body.clientHeight > 1;
      btn.hidden = !overflows;
    });
  }
  document.addEventListener("click", function (e) {
    var btn = e.target && e.target.closest && e.target.closest("[data-desc-toggle]");
    if (!btn) return;
    var wrap = btn.closest("[data-desc-clamp]");
    if (!wrap) return;
    var expanded = wrap.classList.toggle("is-expanded");
    btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    var more = btn.querySelector("[data-desc-more]");
    var less = btn.querySelector("[data-desc-less]");
    if (more) more.hidden = expanded;
    if (less) less.hidden = !expanded;
  }, true);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", evaluateClamps, { once: true });
  } else {
    evaluateClamps();
  }
  window.addEventListener("load", evaluateClamps, { once: true });
  var rt;
  window.addEventListener("resize", function () {
    clearTimeout(rt);
    rt = setTimeout(evaluateClamps, 120);
  });
})();
